// pieces and components
const initLoadingBar = stage => {
	const loadingBar = document.querySelector('.global-loading-bar');
	const action =
		loadingBar.style.opacity == 1 && stage != 'done' ? 'move' : stage;

	switch (action) {
		case 'start':
			loadingBar.style.opacity = 1;
			loadingBar.style.width =
				(window.innerWidth * (Math.floor(Math.random() * 6) + 1)) / 10 + 'px';
			break;

		case 'move':
			loadingBar.style.opacity = 1;
			loadingBar.style.width =
				loadingBar.getBoundingClientRect().width * 1.15 + 'px';
			break;

		case 'done':
			loadingBar.style.width = window.innerWidth + 'px';

			setTimeout(function() {
				loadingBar.style.opacity = 0;
			}, 400);

			setTimeout(function() {
				loadingBar.style.width = 0;
			}, 800);
			break;
	}
};

const initItemQuantity = () => {
	document.addEventListener('click', e => {
		if (
			e.target &&
			(e.target.dataset.quantityTrigger ||
				e.target.closest('[data-quantity-trigger]'))
          
		) {
			let target = e.target.dataset.quantityTrigger
				? e.target
				: e.target.closest('[data-quantity-trigger]');
			let itemQuantity = target.closest('.item-quantity');
			let quantityInput = itemQuantity.querySelector('input[type="number"]');
			let updatedValue =
				parseInt(quantityInput.value) +
				(target.dataset.quantityTrigger == 'increase'
					? parseInt(quantityInput.value) + 1 <= parseInt(quantityInput.max)
						? 1
						: 0
					: parseInt(quantityInput.value) - 1 >= parseInt(quantityInput.min)
					? -1
					: 0);

			quantityInput.value = target.classList.contains('has-leading-zero')
				? formatLeadingZero(updatedValue)
				: updatedValue;

             var closestForm = quantityInput.closest("form");
             if(closestForm && closestForm.querySelector('[name="dispenser quantity"]')){
               closestForm.querySelector('[name="dispenser quantity"]').value = updatedValue;
             }
		}
	});
};

const initFields = () => {
	const fields = document.querySelectorAll('.field');

	fields.forEach(item => {
		let input = item.querySelector(`input[type="text"],
			input[type="email"],
			input[type="tel"],
			input[type="url"],
			input[type="password"],
			input[type="file"],
			textarea`);
		let determineHasValue = () => {
			input.value
				? item.classList.add('has-value')
				: item.classList.remove('has-value');
		};

		if (input) {
			determineHasValue();
			input.addEventListener('change', () => {
				input.classList.remove('is-error');
				determineHasValue();
			});
			input.addEventListener('blur', determineHasValue);
		}
	});
};

const initFlickitySlider = () => {
	const flickitySlider = document.querySelectorAll('[data-flickity-slider]');

	const flickitySliderTrigger = () => {
		flickitySlider.forEach(el => {
			let flickity = new Flickity(
				el,
				JSON.parse(el.dataset.flickitySlider.replace(/'/g, '"').trim())
			);
            if(!el.querySelector('.flickity-slider')){
              return;
            }
			let childrenWidth = Object.values(
				el.querySelector('.flickity-slider').childNodes
			).reduce(
				(total, i) =>
					i.offsetWidth
						? total +
						  i.offsetWidth +
						  parseInt(window.getComputedStyle(i).marginLeft) +
						  parseInt(window.getComputedStyle(i).marginRight)
						: total,
				0
			);

			if (
				// if total children width is lesser than slider width
				el.getBoundingClientRect().width >= childrenWidth ||
				// if flickity slider has breakpoint set, and window is greater than breakpoint
				(el.dataset.flickityBreakpoint &&
					window.innerWidth > parseInt(el.dataset.flickityBreakpoint))
			) {
				// destroy flickity
				flickity.destroy();
				el.classList.add('flickity-disabled');

				setTimeout(() => {
					el.querySelectorAll('[style*="left:"]').forEach(item => {
						item.style.setProperty('left', 'unset');
					});
				}, 100);

				let sliderPagination = el
					.closest('.section-product-slider')
					?.querySelector('.slider-pagination');

				if (sliderPagination) {
					sliderPagination.remove();
				}
			} else {
				// avoid click on drag: https://github.com/metafizzy/flickity/issues/838
				flickity.on('dragStart', () =>
					flickity.slider.childNodes.forEach(
						slide => (slide.style.pointerEvents = 'none')
					)
				);

				flickity.on('dragEnd', () =>
					flickity.slider.childNodes.forEach(
						slide => (slide.style.pointerEvents = 'all')
					)
				);

				flickity.on('change', index => {
					let event = new CustomEvent('sliderChanged', { detail: index });
					el.dispatchEvent(event);
				});

				if (el.classList.contains('flickity-child-is-equal-height')) {
					let maxHeight = [];

					el.querySelector('.flickity-slider').childNodes.forEach(item => {
						maxHeight.push(item.offsetHeight);
					});

					el.querySelector('.flickity-slider').childNodes.forEach(item => {
						item.style.height = `${Math.max.apply(Math, maxHeight)}px`;
					});
				}
			}
		});
	};

	flickitySliderTrigger();
	window.addEventListener('resize', flickitySliderTrigger);

	// swipe fix for IOS
	var touchingCarousel = false;
	var touchStartCoords;

	document.body.addEventListener('touchstart', function(e) {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}

		touchStartCoords = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY,
		};
	});

	document.body.addEventListener(
		'touchmove',
		function(e) {
			if (!(touchingCarousel && e.cancelable)) {
				return;
			}

			var moveVector = {
				x: e.touches[0].pageX - touchStartCoords.x,
				y: e.touches[0].pageY - touchStartCoords.y,
			};

			if (Math.abs(moveVector.x) > 7) {
				e.preventDefault();
			}
		},
		{
			passive: false,
		}
	);
};

const initAccordion = () => {
	const accordion = document.querySelectorAll('.comp-accordion');

	accordion.forEach(el => {
		el.querySelector('.accordion-label').addEventListener('click', e => {
			if(e.target.classList.contains("gift-note-accordion-label")){
				return;
			}
			// activate current accordion
			slide('toggle', el.querySelector('.accordion-content'));

			!el.classList.contains('is-active')
				? el.classList.add('is-active')
				: el.classList.remove('is-active');

			if (!el.closest('.framer-product-with-image-section-accordions')) {
				accordion.forEach(el2 => {
					if (el2 != el) {
						// inactive all other accordions
						slide('up', el2.querySelector('.accordion-content'));
						el2.classList.remove('is-active');
					}
				});
			}
		});
	});

	document.addEventListener('click', e => {
		if(e.target.classList.contains("gift-note-accordion-label")){
			var el = e.target.closest('.comp-accordion');
			// activate current accordion
			slide('toggle', el.querySelector('.accordion-content'));

			!el.classList.contains('is-active')
				? el.classList.add('is-active')
				: el.classList.remove('is-active');

			if (!el.closest('.framer-product-with-image-section-accordions')) {
				accordion.forEach(el2 => {
					if (el2 != el) {
						// inactive all other accordions
						slide('up', el2.querySelector('.accordion-content'));
						el2.classList.remove('is-active');
					}
				});
			}
		}
		});
	
};

// global elements and pages

const initPageTransition = () => {
	document.querySelectorAll('a[href]').forEach(item => {
		// if href points to anchor, or points to anchor that exists on page
		if (
			item.href.startsWith('#') ||
			(item.href.split('#')[1] &&
				item.href.split('#')[0] == window.location.href.split('#')[0])
		) {
			item.setAttribute('data-page-transition', 'scroll');
		} else if (
			(item.href.includes(siteUrl) || item.href.startsWith('/')) &&
			item.target != '_blank' &&
			!item.href.includes('mailto:')
		) {
			item.setAttribute('data-page-transition', 'internal');
		}
	});

	document.querySelectorAll('[data-page-transition]').forEach(item => {
		item.addEventListener('click', e => {
			let target = e.target.hasAttribute('data-page-transition')
				? e.target
				: e.target.closest('[data-page-transition]');

			target.blur();

			if (
				target.dataset.pageTransition == 'internal' &&
				!root.classList.contains('key-is-down')
			) {
				e.preventDefault();
				root.classList.remove(
					'menu-is-active',
					'minicart-is-active',
					'header-is-sticky'
				);
				root.classList.add('is_leaving');

				setTimeout(function() {
					window.location.href = target.href;
				}, 400);
			} else if (target.dataset.pageTransition == 'scroll') {
				e.preventDefault();
				let selector = document.querySelector(`#${target.href.split('#')[1]}`);
				window.scrollTo({
					behavior: 'smooth',
					top:
						selector.getBoundingClientRect().top -
						document.body.getBoundingClientRect().top -
						offsetTop,
				});
				// seamless.elementScrollIntoView(
				// 	document.querySelector(`#${target.href.split('#')[1]}`),
				// 	{
				// 		behavior: 'smooth',
				// 	}
				// );
			}
		});
	});

	window.addEventListener('keydown', () => {
		root.classList.add('key-is-down');
	});

	window.addEventListener('keyup', () => {
		root.classList.remove('key-is-down');
	});
};

const initPageAnimation = () => {
	document.querySelectorAll('[data-animate]').forEach(item => {
		let observer = new IntersectionObserver(
			el => {
				if (
					el[0].isIntersecting === true &&
					!el[0].target.classList.contains('is-animated')
				) {
					el[0].target.classList.add('is-animated');
				}
			},
			{ threshold: [0.4] }
		); // 0 = page start; 1 = page bottom, items only revealed when in full view

		observer.observe(item);
	});
};

const initContentLayout = () => {
	// iframe fit vids
	reframe(
		'.content-layout iframe[src*="vimeo.com"], .content-layout iframe[src*="youtube.com"]',
		'video-reframe'
	);

	// unwrap image from paragraph tag
	let contentLayout = document.querySelector('.content-layout');
	if (contentLayout) {
		[].forEach.call(contentLayout.getElementsByTagName('img'), function(img) {
			var a = img.closest('p');
			a.parentElement.insertBefore(img, a);
			a.parentElement.removeChild(a);
		});
	}
};

const initSectionProductSlider = () => {
	if (!document.querySelectorAll('.section-product-slider')) return false;

	document.querySelectorAll('.section-product-slider').forEach(section => {
		let slider = section.querySelector('[data-flickity-slider]');

		section.querySelector('.slider-prev')?.addEventListener('click', () => {
			section.querySelector('.flickity-button.previous').click();
		});

		section.querySelector('.slider-next')?.addEventListener('click', () => {
			section.querySelector('.flickity-button.next').click();
		});

		let circle = section.querySelector('circle');
		if (circle) {
			let radius = circle.r.baseVal.value;
			let circumference = radius * 2 * Math.PI;

			let setProgress = percent => {
				const offset = circumference - ((percent - 0.5) / 100) * circumference;
				circle.style.strokeDashoffset = offset;
			};

			circle.style.strokeDasharray = `${circumference} ${circumference}`;
			circle.style.strokeDashoffset = `${circumference}`;

			setProgress(
				parseInt((1 / parseInt(slider.dataset.flickitySliderSize)) * 100)
			);

			slider.addEventListener(
				'sliderChanged',
				e => {
					setProgress(
						parseInt(
							((e.detail + 1) / parseInt(slider.dataset.flickitySliderSize)) *
								100
						)
					);
				},
				false
			);
		}
	});
};

const initSectionTextOverlay = () => {
	if (!document.querySelectorAll('.section-image-text-overlay')) return false;

	document.querySelectorAll('.section-image-text-overlay').forEach(section => {
		const slideMove = e => {
			let target = e.target
				? e.target.hasAttribute('data-slide-trigger')
					? e.target
					: e.target.closest('[data-slide-trigger]')
				: e;

			section.classList.add('is-transitioning');

			slideTrigger.forEach(item => {
				item.dataset.slideTrigger == target.dataset.slideTrigger
					? item.classList.add('is-active')
					: item.classList.remove('is-active');
			});

			setTimeout(() => {
				section.classList.remove('is-transitioning');

				slideElements.forEach(item => {
					item.dataset.slide == target.dataset.slideTrigger
						? item.classList.add('is-active')
						: item.classList.remove('is-active');
				});
			}, 400);
		};

		// auto slide
		const interval = section.dataset.loopInterval;

		let intervalTrigger = setInterval(() => {
			for (let i = 0; i < slideTrigger.length; i++) {
				let el = slideTrigger[i];

				if (el.classList.contains('is-active')) {
					let index = i == slideTrigger.length - 1 ? 0 : i + 1;
					let triggerActive = slideTrigger[index];

					triggerActive.dispatchEvent(
						new CustomEvent('autoMove', triggerActive)
					);

					// exit loop once the new is-active class has been assigned
					break;
				}
			}
		}, interval * 1000);

		if (interval == 0) {
			clearInterval(intervalTrigger);
		}

		// slide triggers
		const slideElements = section.querySelectorAll('[data-slide]');
		const slideTrigger = section.querySelectorAll('[data-slide-trigger]');

		slideTrigger.forEach(item => {
			item.addEventListener('click', e => {
				slideMove(e);
				clearInterval(intervalTrigger);
			});

			item.addEventListener('autoMove', slideMove);
		});
	});
};

const initQuickAddLayout = () => {
	const quickAdds = document.querySelectorAll('.product-quick-add');
	if (!quickAdds) return false;

	// initQuickAddLayout() function only handles layout interactions
	// for the form / add to cart trigger is handled by initCart()

	const closeQuickAddForm = item => {
		if (
			!item.classList.contains('is-always-active') &&
			item.classList.contains('is-active')
		) {
			item.classList.remove('is-active');
			item.setAttribute('aria-hidden', true);
			item.setAttribute('tabindex', -1);
			item.querySelector('.quick-add-toggle').classList.remove('is-active');
		}
	};

	quickAdds.forEach(item => {
		const toggle = item.querySelector('.quick-add-toggle');

		if (window.innerWidth > 900) {
			toggle.addEventListener('mouseover', e => {
				item.classList.add('is-active');
				toggle.classList.add('is-active');
				item.setAttribute('aria-hidden', false);
				item.setAttribute('tabindex', 1);
			});

			item.addEventListener('mouseleave', e => {
				closeQuickAddForm(item);
			});
		}

		toggle.addEventListener('click', e => {
			if (item.classList.contains('is-active')) {
				if (!item.classList.contains('is-always-active')) {
					item.classList.remove('is-active');
					toggle.classList.remove('is-active');
				}

				// item
				// 	.querySelector('form')
				// 	.dispatchEvent(new CustomEvent('submitTrigger'));
			} else if (window.innerWidth <= 900) {
				item.classList.add('is-active');
				toggle.classList.add('is-active');
				item.setAttribute('aria-hidden', false);
				item.setAttribute('tabindex', 1);
			}
		});

		const thumbnail = item.querySelector('.quick-add-thumbnails');
		const dispenser = item.querySelector('.quick-add-dispenser');
		const dispenserInclude = dispenser
			? dispenser.querySelector('[name="include dispenser"]')
			: null;
		const dispenserPrice = dispenser
			? dispenser.querySelector('.dispenser-price span')
			: null;

		if (dispenser && dispenserInclude) {
			dispenserInclude.addEventListener('change', () => {
				if (thumbnail) {

                  
					dispenserInclude.checked == true
						? thumbnail.classList.add('with-dispenser')
						: thumbnail.classList.remove('with-dispenser');

                  if (window.innerWidth < 770) {
                    // $('.product-thumbnail_title--wrapper.custom-product-mobile-dropdown-button + .custom-product-mobile-dropdown-body').slideUp();
                    $('.product-thumbnail_title--wrapper.custom-product-mobile-dropdown-button').removeClass('hide');
                  }
				}

				updateCheckOutPrice();
			});


            document.addEventListener('click', function(e){
            let el = e.target;
            
            if(el.classList.contains('product-thumbnail') || el.closest('.product-thumbnail')) {
            if(!el.classList.contains('product-thumbnail')) {
            el = el.closest('.product-thumbnail');
            }
              e.preventDefault();
              let is_dispenser = el.classList.contains('is-dispenser');
              if(dispenserInclude) {
                
              if(is_dispenser) {
                dispenserInclude.checked = true;
                if (thumbnail) {
                       thumbnail.classList.remove('with-optional-product');
					   thumbnail.classList.remove('with-optional-product-2');
                     }
                } else {
                dispenserInclude.checked = false; 
                 let is_optional_product = el.classList.contains('is-optional-product');
                 if (thumbnail) {
                     if(is_optional_product){
                      thumbnail.classList.add('with-optional-product');
                      if(document.querySelector(".purchase-type:not(.subscription)")){ 
                        document.querySelector(".purchase-type:not(.subscription)").dispatchEvent(new Event("click", { bubbles: true }));  
                      }
                     }else{
                       thumbnail.classList.remove('with-optional-product');
                     }
                 }

				 let is_optional_product_2 = el.classList.contains('is-optional-product-2');
                 if (thumbnail) {
                     if(is_optional_product_2){
                      thumbnail.classList.add('with-optional-product-2');
                      if(document.querySelector(".purchase-type:not(.subscription)")){ 
                        document.querySelector(".purchase-type:not(.subscription)").dispatchEvent(new Event("click", { bubbles: true }));  
                      }
                     }else{
                       thumbnail.classList.remove('with-optional-product-2');
                     }
                 }

                }
                
            dispenserInclude.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
            });
            

		}

		// subscription options
		const purchaseTypes = item.querySelectorAll('.purchase-type');
		const purchaseFrequency = item.querySelector('.purchase-frequency');

		purchaseTypes.forEach(purchaseType => {
			purchaseType.addEventListener('click', el => {
				const form = el.target.closest('form[action="/cart/add"]');
				const target = el.target.closest('.purchase-type');

				purchaseTypes.forEach(purchaseType => {
					purchaseType.classList.remove('is-selected');
					purchaseType.querySelector('input[type="radio"]').checked = false;
				});

				if (purchaseFrequency) {
					purchaseFrequency.classList.remove('is-active');
				}

				target.classList.add('is-selected');

				if (target.classList.contains('subscription')) {
					target.querySelector('input[type="radio"]').checked = true;
					purchaseFrequency.classList.add('is-active');
					form.dataset.activeType = 'subscription';
				} else {
					target.querySelector('input[type="radio"]').checked = true;
					form.dataset.activeType = 'one-time-purchase';
				}

				// update dispenser
				if (item.classList.contains('is-kit') && dispenserInclude) {
					dispenserInclude.value = dispenserInclude.dataset.dispenserKitId;
				}


      
              
				if (dispenser && dispenserInclude && dispenserPrice) {
					if (item.classList.contains('is-kit')) {
						dispenserInclude.value = dispenserInclude.dataset.dispenserKitId;
						dispenserPrice.innerHTML =
							dispenserInclude.dataset.dispenserKitPrice;

						target.classList.contains('subscription')
							? (dispenserInclude.checked = true)
							: (dispenserInclude.checked = false);
					} else {

                    
						// if (target.classList.contains('subscription')) {
						// 	dispenserInclude.value =
						// 		dispenserInclude.dataset.dispenserSubscriptionId;
						// 	dispenserPrice.innerHTML =
						// 		dispenserInclude.dataset.dispenserSubscriptionPrice;
						// } else {
						// 	dispenserInclude.value =
						// 		dispenserInclude.dataset.dispenserRegularId;
						// 	dispenserPrice.innerHTML =
						// 		dispenserInclude.dataset.dispenserRegularPrice;
						// }
					}
				}

				updateCheckOutPrice();

                if (window.innerWidth < 770) {
                  var mobDopdownButtonLabel = target.closest('.custom-product-mobile-dropdown').querySelector('.custom-product-mobile-dropdown-button-label');
                  var mobDopdownButtonPrice = target.closest('.custom-product-mobile-dropdown').querySelector('.custom-product-mobile-dropdown-button-price');
                  if (mobDopdownButtonLabel != null) {
                    mobDopdownButtonLabel.innerHTML = target.querySelector('label').innerHTML;
                  }
                  if (mobDopdownButtonPrice != null) {
                    mobDopdownButtonPrice.innerHTML = target.querySelector('.purchase-type-price').innerHTML;
                  }
                  // $('.custom-product-mobile-dropdown-body').slideUp();
                  // $('.custom-product-mobile-dropdown-button').removeClass('hide');
                }
			});
		});

		// subscription frequency dropdown
		const dropdownWrapper = item.querySelectorAll('.select-wrapper');

		dropdownWrapper.forEach(dropdown => {
			//debugger;
			const dropdownTrigger = dropdown.querySelector('.select-trigger');
			const dropdownSelect = dropdown.querySelector('.select');
			const dropdownOptions = dropdown.querySelectorAll(
				'.custom-options .custom-option'
			);
			const kitItems = item.querySelector('.quick-add-kit-items');
			const propertiesSubscription = dropdown.querySelector(
				'input[name="properties[subscription]"]'
			);

			dropdownOptions.forEach(option => {
				const updateDropdownVal = selectedOption => {
					//update subscription id
					if (propertiesSubscription) {
						propertiesSubscription.value = selectedOption.dataset.valueId;
						propertiesSubscription.dataset.planIndex =
							selectedOption.dataset.valueIndex;
                        if(selectedOption.dataset.valueId =="3000565934"){
                          propertiesSubscription.dataset.planIndex = 0;
                        }
						propertiesSubscription.dataset.sellingPlan = selectedOption.dataset.value
							.replace('(s)', 's')
							.toLowerCase()
							.replace(/\s+/g, '-');
					}
					if (kitItems) {
						kitItems.dataset.sellingPlan = selectedOption.dataset.value
							.replace('(s)', 's')
							.toLowerCase()
							.replace(/\s+/g, '-');
					}
					dropdownTrigger.querySelector('span').innerHTML =
						selectedOption.innerHTML;
				};
				//onload value
				if (option.classList.contains('selected')) {
					updateDropdownVal(option);
				}

				//onclick
				option.addEventListener('click', e => {
					if (e.target.classList.contains('selected')) {
						dropdownSelect.classList.remove('active');
					} else {
						dropdownOptions.forEach(item => {
							item.classList.remove('selected');
						});
						e.target.classList.add('selected');
						updateDropdownVal(e.target);
						dropdownSelect.classList.remove('active');
					}
				});
			});

			//toggle dropdown
			if (dropdownTrigger) {
				dropdownTrigger.addEventListener('click', () => {
					dropdownSelect.classList.toggle('active');
				});

				document.addEventListener('click', e => {
					if (
						dropdownSelect.classList.contains('active') &&
						e.target &&
						!e.target.classList.contains('select-trigger') &&
						!e.target.closest('.select-trigger') &&
						!e.target.classList.contains('custom-options') &&
						!e.target.closest('.custom-options')
					) {
						dropdownSelect.classList.remove('active');
					}
				});
			}
		});

		const quantityWrapper = item.querySelector('.quick-add-quantity');
		const quantityTriggers = quantityWrapper.querySelectorAll(
			'[data-quantity-trigger]'
		);

		quantityTriggers.forEach(quantityTrigger => {
			quantityTrigger.addEventListener('click', el => {
				const target = el.target.closest('[data-quantity-trigger]');
				const input = quantityWrapper.querySelector('input[type="number"]');
				let quantity = input.value;

				if (
					target.dataset.quantityTrigger == 'increase' &&
					quantity < input.max
				) {
					quantity = parseInt(quantity) + 1;
					updateCheckOutPrice(quantity);
				} else if (
					target.dataset.quantityTrigger == 'decrease' &&
					quantity > input.min
				) {
					quantity = parseInt(quantity) - 1;
					updateCheckOutPrice(quantity);
				}
			});
		});

		const updateCheckOutPrice = quantity => {
            // console.log("here!!!");
			const selectedType = item.querySelector('.purchase-type.is-selected');
			const priceWrapper = item.querySelector('.check-out-price');

			if (!quantity) {
				quantity = item.querySelector('input[type="number"]').value;
			}

      let purchasetypesArr = item.querySelectorAll('.purchase-type');
      if(purchasetypesArr.length) {
        purchasetypesArr.forEach(function (type,index) {
          var typePrice = type.dataset.price * quantity;	
		  var typeComparePrice = type.getAttribute("data-price-compare") * quantity;


           if(dispenserInclude && dispenserInclude.checked && type.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product")){
             if(type.classList.contains("subscription")){
             typePrice = type.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product").getAttribute("data-subscription-price_refill_and_pump_linked_product") * quantity;
             }else{
             typePrice = type.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product").getAttribute("data-price_refill_and_pump_linked_product") * quantity;
			 typeComparePrice = type.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product").getAttribute("data-price-compare_refill_and_pump_linked_product") * quantity;
            }
           }
          
          var originalNameIdINput = type.closest(".quick-add-form").querySelector("[data-id-input]");
		 // debugger;
          if(type.dataset.optionalProductPrice && type.closest(".quick-add-form").querySelector(".quick-add-thumbnails.with-optional-product")){
            typePrice = type.dataset.optionalProductPrice * quantity;
            originalNameIdINput.value = type.dataset.optionalProductId;
            type.closest(".quick-add-form").querySelector(".purchase-type-dropdown").style.display = "none";
          }else if(type.dataset['optionalProductPrice-2'] && type.closest(".quick-add-form").querySelector(".quick-add-thumbnails.with-optional-product-2")){
            // debugger;
			typePrice = type.dataset['optionalProductPrice-2'] * quantity;
            originalNameIdINput.value = type.dataset['optionalProductId-2'];
            type.closest(".quick-add-form").querySelector(".purchase-type-dropdown").style.display = "none";
          }else{
            originalNameIdINput.value = type.dataset.originalProductId;
            type.closest(".quick-add-form").querySelector(".purchase-type-dropdown").style.display = "block";
          }
		  console.log(originalNameIdINput.value);
//debugger;
          if(dispenserInclude) {
          if(dispenserInclude.checked) {
           typePrice = typePrice + parseFloat(dispenserPrice.innerHTML.replace('$', ''));

            if(type.closest(".quick-add-form").querySelector(".refill-and-pump-linked-product-subscription-subheading")){
              type.closest(".quick-add-form").querySelector(".refill-and-pump-linked-product-subscription-subheading").removeAttribute("hidden");

            if(type.closest(".quick-add-form").querySelector(".main-product-subscription-subheading")){
              type.closest(".quick-add-form").querySelector(".main-product-subscription-subheading").setAttribute("hidden","");
            }
            }
            
          }else{             
            
            if(type.closest(".quick-add-form").querySelector(".refill-and-pump-linked-product-subscription-subheading")){
              type.closest(".quick-add-form").querySelector(".refill-and-pump-linked-product-subscription-subheading").setAttribute("hidden","");

              if(type.closest(".quick-add-form").querySelector(".main-product-subscription-subheading")){
              type.closest(".quick-add-form").querySelector(".main-product-subscription-subheading").removeAttribute("hidden");
             }
              
            }
          } 
           }else{             
            
            if(type.closest(".quick-add-form").querySelector(".refill-and-pump-linked-product-subscription-subheading")){
              type.closest(".quick-add-form").querySelector(".refill-and-pump-linked-product-subscription-subheading").setAttribute("hidden","");

              if(type.closest(".quick-add-form").querySelector(".main-product-subscription-subheading")){
              type.closest(".quick-add-form").querySelector(".main-product-subscription-subheading").removeAttribute("hidden");
             }
              
            }
          } 
      
          	let typePriceFormatted =
      				typePrice % 1 == 0
      					? Math.round(typePrice * 100) / 100
      					: (Math.round(typePrice * 100) / 100).toFixed(2);

          let isSubcribeRow = type.getAttribute('data-subscription_pricing_factor');
            let typePriceEl = type.querySelector('.purchase-type-price');
          if(typePriceEl) {
       
if(isSubcribeRow != null) {
  typePriceEl.innerHTML = ' ';
  //debugger;
   if(dispenserInclude && dispenserInclude.checked && type.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product")){
                var isSubcribeRowCount = (type.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product").getAttribute("data-subscription_pricing_factor_refill_and_pump_linked_product") * 1);
            }else{
                var isSubcribeRowCount = (isSubcribeRow * 1);
            }
 
  let oldSubcribePrice = typePrice*100/isSubcribeRowCount;
  let oldSubcribePriceFormatted =  Math.round(oldSubcribePrice).toString().replace('.00','');
  
  let tagEl  = document.createElement('s');
  tagEl.innerHTML = '$'+oldSubcribePriceFormatted;
  typePriceEl.appendChild(tagEl);
  typePriceEl.insertAdjacentHTML( 'beforeend', ' $'+typePriceFormatted );

} else {
  if(typeComparePrice != 0){
	typePriceEl.innerHTML = '<s>$'+ typeComparePrice +'</s>' + '$'+typePriceFormatted;
  }else{
	typePriceEl.innerHTML = '$'+typePriceFormatted;
  }
  
}
}          
       
          
        });
      } 

           if(dispenserInclude && dispenserInclude.checked == true && selectedType.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product")){
             if(selectedType.classList.contains("subscription")){
               var checkOutPrice = selectedType.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product").getAttribute("data-subscription-price_refill_and_pump_linked_product") * quantity;
             }else{
               var checkOutPrice = selectedType.closest(".quick-add-form").querySelector(".custom-refill-and-pump-linked-product").getAttribute("data-price_refill_and_pump_linked_product") * quantity;
             }
           }else{
			var checkOutPrice =
				dispenserInclude && dispenserInclude.checked == true
					? parseFloat(selectedType.dataset.price) * quantity +
					  parseFloat(dispenserPrice.innerHTML.replace('$', ''))
					: (selectedType.dataset.optionalProductPrice && selectedType.closest(".quick-add-form").querySelector(".quick-add-thumbnails.with-optional-product")?parseFloat(selectedType.dataset.optionalProductPrice) * quantity:(selectedType.dataset['optionalProductPrice-2'] && selectedType.closest(".quick-add-form").querySelector(".quick-add-thumbnails.with-optional-product-2")?parseFloat(selectedType.dataset['optionalProductPrice-2']):parseFloat(selectedType.dataset.price) * quantity));
            }
			let checkOutPriceFormatted =
				checkOutPrice % 1 == 0
					? Math.round(checkOutPrice * 100) / 100
					: (Math.round(checkOutPrice * 100) / 100).toFixed(2);

		    if(priceWrapper){
				priceWrapper.innerHTML = checkOutPriceFormatted;
			}			
			
//debugger;
			if(selectedType.closest(".product-hero")){
			var heroSubtitles = selectedType.closest(".product-hero").querySelectorAll(".hero-title .hero-subtitle");	

			if(heroSubtitles.length){
			  heroSubtitles.forEach((heroSubtitle) => {		
				
				if(selectedType.dataset.optionalProductPrice && selectedType.closest(".quick-add-form").querySelector(".quick-add-thumbnails.with-optional-product")){
					heroSubtitle.innerHTML = selectedType.dataset.optionalProductVolume + "<span>$"+checkOutPriceFormatted+"</span>";
				}else if(selectedType.dataset['optionalProductPrice-2'] && selectedType.closest(".quick-add-form").querySelector(".quick-add-thumbnails.with-optional-product-2")){
					heroSubtitle.innerHTML = selectedType.dataset['optionalProductVolume-2'] + "<span>$"+checkOutPriceFormatted+"</span>";		
				}else{
				    heroSubtitle.innerHTML = selectedType.dataset.originalVolume + "<span>$"+checkOutPriceFormatted+"</span>";
				}

			  });			
			}
		  }
			var quickBuyButton = selectedType.closest("form").querySelector(".quick-add-toggle");
			var quickBuyButtonOptional = selectedType.closest("form").querySelector(".quick-add-toggle-optional-soldout");
			if(quickBuyButton && quickBuyButtonOptional){
				if(selectedType.dataset.optionalProductPrice && selectedType.closest(".quick-add-form").querySelector(".quick-add-thumbnails.with-optional-product")){
					if(selectedType.dataset.optionalProductAvailable == "true"){
						quickBuyButtonOptional.setAttribute("hidden",true);	
						quickBuyButton.removeAttribute("hidden");	
					}else{
						quickBuyButtonOptional.removeAttribute("hidden");	
						quickBuyButton.setAttribute("hidden",true);	
					}
				}else if(selectedType.dataset['optionalProductPrice-2'] && selectedType.closest(".quick-add-form").querySelector(".quick-add-thumbnails.with-optional-product-2")){
					
					if(selectedType.dataset['optionalProductAvailable-2'] == "true"){
						quickBuyButtonOptional.setAttribute("hidden",true);	
						quickBuyButton.removeAttribute("hidden");	
					}else{
						quickBuyButtonOptional.removeAttribute("hidden");	
						quickBuyButton.setAttribute("hidden",true);	
					}
				}else{
					quickBuyButtonOptional.setAttribute("hidden",true);	
					quickBuyButton.removeAttribute("hidden");	
				}
			}
		};
	});

	document.addEventListener('click', e => {
		document.querySelectorAll('.product-quick-add').forEach(item => {
			if (e.target.closest('.product-quick-add') != item) {
				closeQuickAddForm(item);
			}
		});
	});

  const reserve_stock_soldout_btn = document.querySelector('.reserve_stock_soldout_product_btn');
  if(reserve_stock_soldout_btn) {
    const closeOutOfStockModalCloseBtn =  document.querySelector('.custom_klaviyo_modal .close-box');
    function closeOutOfStockModal() {
   const modalEl = document.querySelector('.custom_klaviyo_modal');
      if(modalEl) {
        modalEl.classList.remove('active');
      }
}

    if(closeOutOfStockModalCloseBtn) {
      closeOutOfStockModalCloseBtn.addEventListener('click', function (e) {
      e.preventDefault();
       closeOutOfStockModal();
    });


      document.addEventListener('click', function(e){
  	var el = e.target;
    
    if(el.classList.contains('custom_klaviyo_modal')) {
       closeOutOfStockModal();
    }
  });
      

      
    }
    reserve_stock_soldout_btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();


      const modalEl = document.querySelector('.custom_klaviyo_modal');
      if(modalEl) {
        modalEl.classList.add('active');
      }
    });
  }
  
  const custom_klaviyo_modalSubmitBtn = document.querySelector('.custom_klaviyo_modal .email-me-submitButton');
  if(custom_klaviyo_modalSubmitBtn) {
    custom_klaviyo_modalSubmitBtn.addEventListener('click', function(e) {
      e.preventDefault();
      let outofstock_id = this.getAttribute('data-outofstock_id');
      let modalWrapper = this.closest('.custom_klaviyo_modal');
      let buyer_name = modalWrapper.querySelector('.buyer-name').value;
      let buyer_email = modalWrapper.querySelector('.buyer-email').value;
      const invalid_email_tipsEl = modalWrapper.querySelector('.invalid-email-tips');
      const successed_subscribed_messageEl = modalWrapper.querySelector('.successed_subscribed_message'); 

      console.log(successed_subscribed_messageEl);
      
      if(buyer_email.length == 0) {
        invalid_email_tipsEl.classList.add('show');
         return false;
      } else {
         invalid_email_tipsEl.classList.remove('show');
      }

      var settings = {
  "async": true,
  "crossDomain": true,
  "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
  "method": "POST",
  "headers": {
  "content-type": "application/x-www-form-urlencoded",
  "cache-control": "no-cache"
  },
  "data": {
  "g": outofstock_id, 
  "email": buyer_email,
  "$first_name":buyer_name
  }
  };

      $.ajax(settings).done(function(response) {
      console.log(response);

        let is_subscribed = response.success;
        if(is_subscribed) {
          if(successed_subscribed_messageEl) {
            successed_subscribed_messageEl.removeAttribute('hidden');
          }
        }
    });
     


});
  }
  
};

const initIngredientCard = () => {
	if (!document.querySelectorAll('[data-ingredient-hover]')) return false;

	// clone items
	document.querySelectorAll('[data-ingredient-hover]').forEach(item => {
		if (
			isTablet ||
			// already has ingredient card appended
			document.querySelector(
				`[data-ingredient="${item.dataset.ingredientHover}"]`
			)
		) {
			item.querySelector('.ingredient-card').remove();
			return false;
		}

		let itemClone = item.querySelector('.ingredient-card').cloneNode(true);
		itemClone.setAttribute('data-ingredient', item.dataset.ingredientHover);
		document.body.appendChild(itemClone);
		item.querySelector('.ingredient-card').remove();
	});

	// interactions
	on('body', 'mouseover', '[data-ingredient-hover]', e => {
		let target = e.target.hasAttribute('data-ingredient-hover')
			? e.target
			: e.target.closest('[data-ingredient-hover');
		let card = document.querySelector(
			`[data-ingredient="${target.dataset.ingredientHover}"]`
		);

        var card_holder = target.closest(".product-ingredients-section-items").querySelector(".ingredient-card");
        card_holder.classList.add("fadeout-ingredient-card");
      
		card.classList.add('is-active');
		card.style.left = `${e.screenX}px`;
		card.style.top = `${e.screenY}px`;
	});

	on('body', 'mousemove', '[data-ingredient-hover]', e => {
      
		let target = e.target.hasAttribute('data-ingredient-hover')
			? e.target
			: e.target.closest('[data-ingredient-hover');
		let card = document.querySelector(
			`[data-ingredient="${target.dataset.ingredientHover}"]`
		);

        var anchor = e.target.closest(".product-ingredients-section-items-all-text").querySelector(".specific_ingredients_link");
	    var card_holder = target.closest(".product-ingredients-section-items").querySelector(".ingredient-card");	
        card_holder.classList.add("fadeout-ingredient-card");
      
        if(anchor){
        card.style.left = `${anchor.getBoundingClientRect().x}px`;
		card.style.top = `${anchor.getBoundingClientRect().y}px`;
        }
	});

	on('body', 'mouseout', '[data-ingredient-hover]', e => {
		let target = e.target.hasAttribute('data-ingredient-hover')
			? e.target
			: e.target.closest('[data-ingredient-hover');
		document
			.querySelector(`[data-ingredient="${target.dataset.ingredientHover}"]`)
			.classList.remove('is-active');
      
        var card_holder = target.closest(".product-ingredients-section-items").querySelector(".ingredient-card");
        card_holder.classList.remove("fadeout-ingredient-card");
      
	});

   on('body', 'click', '[data-ingredient-hover]', e => {
   if(window.innerWidth >= 770){
     let target = e.target.hasAttribute('data-ingredient-hover')
			? e.target
			: e.target.closest('[data-ingredient-hover');
		let card = document.querySelector(
			`[data-ingredient="${target.dataset.ingredientHover}"]`
		);
     var active_ingredient_card_target = target.closest(".product-ingredients-section-items").querySelector(".active-ingredient-card-target");
     if(active_ingredient_card_target){
       active_ingredient_card_target.classList.remove("active-ingredient-card-target");
     }
     var card_holder = target.closest(".product-ingredients-section-items").querySelector(".ingredient-card");
     card_holder.innerHTML = card.innerHTML;
     card_holder.classList.add("visible-ingredient-card");
     target.classList.add("active-ingredient-card-target");
   }
     });
  
};

const productSingle = () => {
	const heroSection = document.querySelector('.product-hero');
	const heroImagesNav = document.querySelector('.hero-images-nav');

	// set dynamic css variables for .hero-images-nav
	root.style.setProperty(
		'--s-hero-images-nav',
		`${heroImagesNav ? heroImagesNav.offsetHeight : 0}px`
	);

	on('body', 'click', '.header-product-add-to-cart-trigger', e => {
		heroSection
			.querySelector('.quick-add-form')
			.dispatchEvent(new CustomEvent('submitTrigger'));
	});

	// Flickity - custom navigation for .hero-images-gallery
	const utils = window.fizzyUIUtils;
	const heroImagesGallery = document.querySelector('.hero-images-gallery');
	const heroImagesNavItem = utils.makeArray(heroImagesNav.children);
	const galleryFlkty = new Flickity(heroImagesGallery, {
		pageDots: true,
		prevNextButtons: true,
		wrapAround: true,
		cellAlign: 'center',
		fade: true,
	});

	// Flickity - update .hero-images-nav on select
	galleryFlkty.on('select', function() {
		var prevSelectedItem = heroImagesNav.querySelector('.is-active');
		var selectedItem = heroImagesNav.children[galleryFlkty.selectedIndex];
		prevSelectedItem.classList.remove('is-active');
		selectedItem.classList.add('is-active');
	});

	// update .hero-images-gallery on click
	heroImagesNav.addEventListener('click', e => {
		if (!matchesSelector(e.target, '.hero-images-thumbnail')) {
			return;
		}
		let index = heroImagesNavItem.indexOf(e.target);
		galleryFlkty.select(index);
	});

	on('body', 'click', '.hero-images .video-play', e => {


      let productVideoWrapper = e.target.closest('[data-product-image]');
      if(productVideoWrapper) {
        if(productVideoWrapper.querySelector('video')) {
          productVideoWrapper.querySelector('video').play();
          		productVideoWrapper.classList.add('is-playing');

        }
      }
			
			

	});

	on('body', 'click', '.hero-images video', e => {
		e.target.pause();
		e.target.closest('[data-product-image').classList.remove('is-playing');
	});

	on('body', 'change', '#ingredients-selector', e => {
		let selectedProduct = e.target.value;

		document.querySelectorAll('[data-kit-ingredients]').forEach(el => {
			el.dataset.kitIngredients == selectedProduct
				? el.classList.add('is-active')
				: el.classList.remove('is-active');
		});
	});

  const productTextColumnsSlider = document.querySelector('.product-text-columns-section-grid');
  if (productTextColumnsSlider != null) {
    const productTextColumnsSliderFlkty = new Flickity(productTextColumnsSlider, {
		pageDots: true,
		prevNextButtons: true,
		wrapAround: false,
		cellAlign: 'center',
        watchCSS: true
	});
  }

  const productHowItWorksSlider = document.querySelector('.product-how-it-works-section-slider');
  var productHowItWorksSliderPrevButton = document.querySelector('.product-how-it-works-section-slider-wrapper .button--previous');
  var productHowItWorksSliderNextButton = document.querySelector('.product-how-it-works-section-slider-wrapper .button--next');
  if (productHowItWorksSlider != null) {
    const productHowItWorksSliderFlkty = new Flickity(productHowItWorksSlider, {
		pageDots: true,
		prevNextButtons: false,
		wrapAround: false,
		cellAlign: 'center',
        watchCSS: true
	});

    if (productHowItWorksSliderPrevButton != null) {
      productHowItWorksSliderPrevButton.addEventListener( 'click', function() {
        productHowItWorksSliderFlkty.previous();
      });
    }

    if (productHowItWorksSliderNextButton != null) {
      productHowItWorksSliderNextButton.addEventListener( 'click', function() {
        productHowItWorksSliderFlkty.next();
      });
    }
  }

  const productCustomReviews = document.querySelector('.product-metafields-section-6-grid');
  if (productCustomReviews != null) {
    const productCustomReviewsSliderFlkty = new Flickity(productCustomReviews, {
		pageDots: true,
		prevNextButtons: true,
		wrapAround: false,
		cellAlign: 'center',
        watchCSS: true
	});
  }
};

const initCart = () => {
	// cart visibility
	const minicartClose = () => {
		root.classList.remove('minicart-is-active');
		//history.pushState(null, null, ' ');
	};

	const minicartOpen = () => {
		//debugger;
		root.classList.add('minicart-is-active');
		root.classList.remove('menu-is-active');
		//history.pushState(null, null, '#cart');
       if(document.body.classList.contains("enable_cart_scrolling")){
         setTimeout(function(){
         var objDiv = document.querySelector(".minicart_anchor");
         if(objDiv){
          objDiv.scrollIntoView({ behavior: "smooth", block: "end" })
         }
        },400);
       }
	};

	document.addEventListener('click', e => {
		// open cart trigger
		if (
			e.target &&
			(e.target.classList.contains('minicart-open') ||
				e.target.closest('.minicart-open'))
		) {
			root.classList.contains('minicart-is-active')
				? minicartClose()
				: minicartOpen();
		}

		// close cart trigger
		if (
			e.target &&
			(e.target.classList.contains('minicart-close') ||
				e.target.closest('.minicart-close'))
		) {
			minicartClose();
		}

		if (
			root.classList.contains('minicart-is-active') &&
			e.target &&
			!e.target.classList.contains('minicart-open') &&
			!e.target.closest('.minicart-open') &&
			!e.target.classList.contains('global-minicart') &&
			!e.target.closest('.global-minicart')
		) {
			minicartClose();
		}
	});

	// trigger cart if url contains the hash
	if (location.hash == '#cart') {
		minicartOpen();
	}

	this.getCartData = cartItemsEl => {
		let cartItemsArray = JSON.parse(
			(
				cartItemsEl || document.querySelector('#cart-items-array')
			).dataset.cartItems
				.replace(/'/g, '"')
				.trim()
				.replace(jsonRegex, '')
		);

		let uniqueKitsArray = [];
		let cartItemCount = 0;

		for (let i = 0; i < cartItemsArray.length; i++) {
			if (cartItemsArray[i]._kitHandle) {
				if (
					!uniqueKitsArray.includes(cartItemsArray[i]._kitHandle) &&
					cartItemsArray[i].itemHandle != document.body.getAttribute("data-dispenser-handle")
				) {
					cartItemCount += cartItemsArray[i].quantity;
					uniqueKitsArray.push(cartItemsArray[i]._kitHandle);
				}
			} else {
				cartItemCount += cartItemsArray[i].quantity;
			}
		}

		return {
			items: cartItemsArray,
			count: cartItemCount,
		};
	};

	this.matchItemKeysFromCartArray = item => {
		let cartItemsArray = getCartData().items;
		let itemKeys = [];
        
		for (let i = 0; i < cartItemsArray.length; i++) {
         // debugger;
			if (
				item.dataset.kitHandle &&
				item.dataset.kitHandle == cartItemsArray[i]._kitHandle
			) {
				if (cartItemsArray[i].itemHandle == document.body.getAttribute("data-dispenser-handle")) {
					let itemSameKit = cartItemsArray.filter(function(k) {
						return k._kitHandle == item.dataset.kitHandle;
					});

					// dispenser needs to have a different quantity structure
					itemKeys.push({
						key: cartItemsArray[i].key,
						kitSize: itemSameKit.length - 1,
					});
				} else {
					itemKeys.push(cartItemsArray[i].key);
				}
			}else if (
				item.dataset.kitHandle &&
				item.dataset.kitHandle == (cartItemsArray[i]._kitHandle + "-delivery-every-" + cartItemsArray[i]._kitSellingPlanValue)
			) {
				itemKeys.push(cartItemsArray[i].key);
			} else if (item.dataset.itemKey == cartItemsArray[i].key) {
				itemKeys.push(cartItemsArray[i].key);
			}
		}

		return itemKeys;
	};

	// updates both cart price and item count
	this.reloadCartData = () => {
		// update item count
		fetch('/cart#cart-items-array')
			.then(response => {
				return response.text();
			})
			.then(data => {
				var parser = new DOMParser();
				var dataHtml = parser.parseFromString(data, 'text/html');
				let itemCount = getCartData(dataHtml.querySelector('#cart-items-array'))
					.count;

				document.querySelectorAll('.cart-total-items').forEach(item => {
					item.innerText = itemCount;
					item.style.animation = `0.2s fadeIn both`;
				});

				itemCount > 0
					? root.classList.add('cart-has-items')
					: root.classList.remove('cart-has-items');
              
			})
			.catch(error => {
				console.error('Error:', error);
			});

		// update pricing and free shipping progress bar
		fetch('/cart.js')
			.then(function(response) {
				return response.json();
			})
			.then(data => {
				let cartTotal = parseFloat(data.total_price / 100);

				document.querySelectorAll('.cart-total-price').forEach(item => {
					item.innerText = `$${cartTotal.toFixed(2)}`;
				});

				const freeShippingProgressBar = document.querySelector(
					'.minicart-free-shipping-progress-bar'
				);

                const freeShippingNeedsVal = document.querySelector(
					'.free-shipping-needs-val'
				);
				 const freeProductNeedsVal = document.querySelector(
					'.free-product-needs-val'
				);

               var freeShippingThreshold = freeShippingProgressBar.dataset.freeShippingThreshold;
			   var foundSubscriptionProduct = false;
			   data.items.forEach(item => {
				if( typeof(item.selling_plan_allocation) != "undefined"){
					foundSubscriptionProduct = true;
			    }
			   });
			   
			   var freeProductThreshold = freeShippingProgressBar.dataset.freeProductThreshold;
				//debugger;
               if(data.items.length == 1 && data.items[0].handle == "24-hour-serum-deluxe-mini"){
                 freeShippingThreshold = 0;
               }

				if (freeShippingProgressBar) {
					if(freeProductThreshold !="" && freeProductThreshold != null){
						var freeShippingProgressBarPrecentage =
						(cartTotal /
							parseInt(freeProductThreshold)) *
						100;
						 if (freeProductNeedsVal) {
                    freeProductNeedsVal.innerHTML = '$' + (+freeProductThreshold - cartTotal).toFixed(2);
                  }

					}else{
					var freeShippingProgressBarPrecentage =
						(cartTotal /
							parseInt(freeShippingThreshold)) *
						100;

						}
				
				  if (freeShippingNeedsVal) {
                    freeShippingNeedsVal.innerHTML = '$' + (+freeShippingThreshold - cartTotal).toFixed(2);
                  }

				  if(foundSubscriptionProduct && freeShippingProgressBarPrecentage < freeShippingThreshold){
					freeShippingProgressBarPrecentage = freeShippingProgressBar.dataset.freeShippingThreshold;
				  }
				  if(document.querySelector(".shipping-bar-shipping-point")){
				   var cartFreeMessage = document.querySelector(".shipping-bar-shipping-point").getAttribute("data-cart-free-message");
				   if(foundSubscriptionProduct){
					document.querySelector(".shipping-bar-shipping-point").innerHTML = "Subscription" + "<br>" + cartFreeMessage;
				   }else{
					document.querySelector(".shipping-bar-shipping-point").innerHTML = "$" + freeShippingProgressBar.dataset.freeShippingThreshold + "<br>" + cartFreeMessage;
				   }
				}

				freeShippingProgressBar.style.width =
						freeShippingProgressBarPrecentage < 100
							? `${freeShippingProgressBarPrecentage}%`
							: `100%`;

				}


				 if(freeProductThreshold !="" && freeProductThreshold != null && typeof(freeProductThreshold) != "undefined"){
					var freeShippingUnavaliableBlock = document.querySelector(".free-shipping-unavaliable");
					var freeShippingAvaliableBlock = document.querySelector(".free-shipping-avaliable");
					var freeProductUnavaliableBlock = document.querySelector(".free-product-unavaliable");
					var freeProductAvaliableBlock = document.querySelector(".free-product-avaliable");

				if(cartTotal >= freeProductThreshold){
                    freeShippingUnavaliableBlock.style.display = "none";
					freeShippingAvaliableBlock.style.display = "none";
					freeProductUnavaliableBlock.style.display = "none";
					freeProductAvaliableBlock.style.display = "block";
                  }else if((cartTotal >= freeShippingThreshold || (foundSubscriptionProduct && cartTotal < freeShippingThreshold)) && cartTotal < freeProductThreshold){
					 freeShippingUnavaliableBlock.style.display = "none";
					 freeShippingAvaliableBlock.style.display = "block";
					 freeProductUnavaliableBlock.style.display = "block";
					 freeProductAvaliableBlock.style.display = "none";	
				  }else{
                     freeShippingUnavaliableBlock.style.display = "block";
					 freeShippingAvaliableBlock.style.display = "none";
					 freeProductUnavaliableBlock.style.display = "none";
					 freeProductAvaliableBlock.style.display = "none";	
                  }	
				}else{
					var freeShippingUnavaliableBlock = document.querySelector(".free-shipping-unavaliable");
					var freeShippingAvaliableBlock = document.querySelector(".free-shipping-avaliable");

					if(cartTotal > freeShippingThreshold){
                    freeShippingUnavaliableBlock.style.display = "none";
					freeShippingAvaliableBlock.style.display = "block";
                  }
				  else{
                     freeShippingUnavaliableBlock.style.display = "block";
					 freeShippingAvaliableBlock.style.display = "none";
                  }	
				}

                 var free_item_in_shipping_bar = document.querySelector(".minicart-free-shipping-progress-with-free-item .cart-item");
                if(free_item_in_shipping_bar){
                  var freeItemThreshold = document.body.getAttribute("data-minimum-cart-threshold") * 1;

				 
				 
                  if(cartTotal > freeItemThreshold){
                    free_item_in_shipping_bar.style.display = "none";
                  }else{
                    free_item_in_shipping_bar.style.display = "flex";
                  }
				
                }
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// updates .cart-items HTML
	this.reloadCartItems = () => {
		reloadCartData();

		fetch('/cart')
			.then(response => {
				return response.text();
			})
			.then(data => {
				var parser = new DOMParser();
				var dataHtml = parser.parseFromString(data, 'text/html');

				// insert the new cart items
				document.querySelectorAll('.cart-items-wrapper').forEach(item => {
					item.innerHTML = dataHtml.querySelector(
						'.cart-items-wrapper'
					).innerHTML;
				});

               var updated_items_wrapper = document.querySelector('.cart-items-wrapper');
				var totalCartContainer = document.querySelector('.cart-total-price');
              var totalCartValue = 0
              if(totalCartContainer){
                 totalCartValue= totalCartContainer.innerHTML.replace("$","");
                 totalCartValue = totalCartValue * 1;
                 totalCartValue = totalCartValue.toFixed(0) * 1;
              }

			  if(totalCartValue == 0){
					fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
			  }

              if(updated_items_wrapper){
                var updated_items = updated_items_wrapper.querySelectorAll('.cart-item');

                if(updated_items.length == 1){
                  if(updated_items[0].getAttribute("data-item-id") == document.body.getAttribute("data-dispenser-id")){
                    fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
                    
                  }else if(document.body.getAttribute("data-free-variant-id-for-all") != "" && typeof(document.body.getAttribute("data-free-variant-id-for-all")) != "null"){
                    var dataFreeVariantIdForAll = document.body.getAttribute("data-free-variant-id-for-all");
                    if(updated_items[0].getAttribute("data-item-id") == dataFreeVariantIdForAll){
                    fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
                    
                  }
                  }
                }else if(updated_items.length == 0){
                   fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
                }
              }
              var foundFreeOrderProductVariant = false;
              var dataFreeOrderProductVariantId = document.body.getAttribute("data-free-order-product-id");
			   var foundFreeOrderProductVariantForAll = false;
              var dataFreeOrderProductVariantIdForAll = document.body.getAttribute("data-free-variant-id-for-all");
              updated_items.forEach(function(item){
                  var dataFreeVariantId = document.body.getAttribute("data-free-variant-id");
                  if(item.getAttribute("data-item-id") == dataFreeVariantId && item.getAttribute("data-found-serum") == "false"){
                      fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                      body: '{"updates":{"'+dataFreeVariantId+'":0}}',    
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
                  }

                  if(item.getAttribute("data-item-id") == dataFreeOrderProductVariantId){
                    foundFreeOrderProductVariant = true;
                  }

				  if(item.getAttribute("data-item-id") == dataFreeOrderProductVariantIdForAll){
                    foundFreeOrderProductVariantForAll = true;
                  }

				  
                });

              
              
              
              if(document.body.getAttribute("data-free-order-product-id") != ""){
                var minimumCartThreshold = document.body.getAttribute("data-minimum-cart-threshold") * 1;
                if(totalCartValue >= minimumCartThreshold && !foundFreeOrderProductVariant){
                  let formData = {
                   'items': [{
                    'id': dataFreeOrderProductVariantId,
                    'quantity': 1
                    }]
                  };
                    fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                      body: JSON.stringify(formData),    
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
                }else if(totalCartValue < minimumCartThreshold && foundFreeOrderProductVariant){
                  fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                      body: '{"updates":{"'+dataFreeOrderProductVariantId+'":0}}',    
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
                }
              }


			  if(document.body.getAttribute("data-free-variant-id-for-all") != null){
                var minimumCartThreshold = document.body.getAttribute("data-free-product-for-all-thershold") * 1;
                if(totalCartValue >= minimumCartThreshold && !foundFreeOrderProductVariantForAll){
                  let formData = {
                   'items': [{
                    'id': dataFreeOrderProductVariantIdForAll,
                    'quantity': 1
                    }]
                  };
                    fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                      body: JSON.stringify(formData),    
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
                }else if(totalCartValue < minimumCartThreshold && foundFreeOrderProductVariantForAll){
                  fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                      body: '{"updates":{"'+dataFreeOrderProductVariantIdForAll+'":0}}',    
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
                }
              }



              console.log('reloadCartItems');

                var cartSampleProducts = document.querySelector('.cart_sample_products');
                if (cartSampleProducts) {
                
                  const sample_product_size = cartSampleProducts.querySelectorAll('.sample_product');
                  
                  if(sample_product_size.length > 4) {
                    var cartSampleProductsFlkty = new Flickity( cartSampleProducts, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    pageDots: false
                    });
                  }
                }
                
                var cartUpsellProductReviews = document.querySelectorAll('.cart_upsell_product_reviews');
                if (cartUpsellProductReviews.length) {
                  cartUpsellProductReviews.forEach(function (item) {
                    var autopplaySpeed = item.getAttribute("data-autoplay") * 1;
                    const cartUpsellProductReviewsFlkty = new Flickity(item, {
                      pageDots: true,
                      prevNextButtons: false,
                      wrapAround: true,
                      cellAlign: 'center',
                      autoPlay:autopplaySpeed
                    });
                  });
                }

				var cartUpsellProducts = document.querySelectorAll('.cart_upsell_products:not(.minicart_christmas_gifts--cart_upsell_products)');
                if (cartUpsellProducts.length) {
                  cartUpsellProducts.forEach(function (item) {
                    var autopplaySpeed = item.getAttribute("data-autoplay") * 1;
                    const cartUpsellProductsFlkty = new Flickity(item, {
                      pageDots: true,
                      prevNextButtons: false,
                      wrapAround: true,
                      autoPlay:autopplaySpeed
                    });
                  });
                }
              
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// use this function to add items
	this.addItem = (
		items,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 1200,
		callback
	) => {
		initLoadingBar('start');

    
		fetch('/cart/add.js', {
			method: 'POST',
			body: JSON.stringify({
				items: items,
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then(response => {
				response.json();
			})
			.then(data => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				debugger;
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';
				initLoadingBar('done');

				if (callback) {
					callback();
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	// use this function to change item quantity
	this.changeItemQuantity = (
		itemKeys,
		quantity,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 400,
		callback
	) => {
		let itemUpdates = {};

      console.log(updateCartItems);
      debugger;
		for (let i = 0; i < itemKeys.length; i++) {
			if (itemKeys[i] instanceof Object) {
				itemUpdates[itemKeys[i].key] = parseInt(quantity) * itemKeys[i].kitSize;
			} else {
				itemUpdates[itemKeys[i]] = parseInt(quantity);
			}
		}

		fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				updates: itemUpdates,
			}),
		})
			.then(response => {
				response.json();
			})
			.then(() => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';

				if (callback) {
					callback();
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	};

	const globalMinicart = document?.querySelector('.global-minicart');

	globalMinicart?.addEventListener('click', e => {
		// change quantity trigger
		if (
			e.target &&
			(e.target.dataset.quantityTrigger ||
				e.target.closest('[data-quantity-trigger]'))
		) {
			let target = e.target.dataset.quantityTrigger
				? e.target
				: e.target.closest('[data-quantity-trigger]');
			let item = target.closest('.cart-item');

			item.querySelectorAll('[name="quantity"]').forEach(item => {
				item.value = target
					.closest('.item-quantity')
					.querySelector('[name="quantity"]').value;
			});

			setTimeout(() => {
				changeItemQuantity(
					matchItemKeysFromCartArray(item),
					item.querySelector('[name="quantity"]').value,
					true,
					true,
					false
				);
			}, 1);
		}

		// remove item trigger
		if (
			e.target &&
			(e.target.classList.contains('item-remove-trigger') ||
				e.target.closest('.item-remove-trigger'))
		) {
			let target = e.target.classList.contains('item-remove-trigger')
				? e.target
				: e.target.closest('.item-remove-trigger');
			let item = target.closest('.cart-item');

			changeItemQuantity(
				matchItemKeysFromCartArray(item),
				0,
				true,
				true,
				true,
				() => {
					item.remove();
				}
			);
		}
	});

	// product form submissions

  
	document.querySelectorAll('form[action="/cart/add"]').forEach(form => {

		const formSubmitTrigger = () => {
debugger;
            const freeBodyTool = form.querySelector(".free_body_tool");
            const freeBodyToolInCart = document.querySelector(".free_body_tool_in_cart");
            const freeBodyToolForAll = form.querySelector(".free_body_tool_for_all");
            const freeBodyToolInCartForAll = document.querySelector(".free_body_tool_in_cart_for_all");
            var useCustomRefillAndPumpLinkedProduct = false;
            var useCustomRefillAndPumpLinkedProductID = "";
			var dispenser = form.querySelector('.quick-add-dispenser');
			var dispenserInclude = dispenser?.querySelector(
				'[name="include dispenser"]'
			);
			const kitItems = form.querySelector('.quick-add-kit-items');
			const purchaseTypeOneTimeCheckBox = form.querySelector(
				'input[id*="purchase-type-one-time"]'
			);
			let items = [];

			const isSubscription = form.dataset.activeType.includes('subscription');
			const propertiesSubscription = form.querySelector(
				'input[name="properties[subscription]"]'
			);
			let sellingPlan = '';

			if (
				isSubscription &&
				propertiesSubscription &&
				!purchaseTypeOneTimeCheckBox.checked
			) {
				sellingPlan = propertiesSubscription.value;
			}

            if(dispenser && dispenserInclude.checked && form.querySelector(".custom-refill-and-pump-linked-product")){
              dispenser = null;
			  dispenserInclude = null;
              useCustomRefillAndPumpLinkedProduct = true;
              useCustomRefillAndPumpLinkedProductID = form.querySelector(".custom-refill-and-pump-linked-product").getAttribute("data-variant-id");
              if(sellingPlan != ""){
                sellingPlan = form.querySelector(".custom-refill-and-pump-linked-product").getAttribute("data-subscription-id");
              }
            }

			if (kitItems && !purchaseTypeOneTimeCheckBox.checked) {
             
				const quantity = form.querySelector('[name="quantity"]').value;
				const sellingPlanIndex = form.querySelector(
					'[name="properties[subscription]"]'
				).dataset.planIndex;


              let kitItemsString = kitItems.dataset.kitItemsArray;
              console.log(kitItemsString);
              let kitItemsArray = kitItemsString.replace('["','').replace('"]','').split(',');
                            
              
				// const kitItemsArray = JSON.parse(
				// 	kitItems.dataset.kitItemsArray
				// 		.replace(/'/g, '"')
				// 		.trim()
				// 		.replace(jsonRegex, '')
				// );

				// add in-kit products
                var foundBodyGuaShaTool = false;
				kitItemsArray.forEach(i => {
                 debugger;
					const kitProduct =
						inKitProducts[inKitProducts.findIndex(p => p.handle == i)];
                    if(i == "24-hour-serum-uni-body-gua-sha-tool"){
                      foundBodyGuaShaTool = true;
                    }
              
                  
					if (kitProduct) {
                         debugger;
						if (kitProduct.sellingPlan.length > 1) {
							sellingPlan = kitProduct.sellingPlan[sellingPlanIndex];
						} else {
							sellingPlan = kitProduct.sellingPlan[0];
						}
						items.push({
							id: kitProduct.variantId,
							selling_plan: sellingPlan,
							quantity: quantity,
							properties: {
								_kitHandle: kitItems.dataset.kitHandle,
								_kitTitle: kitItems.dataset.kitTitle,
								_kitPrice: parseInt(kitItems.dataset.kitPrice),
								_kitImageUrl: kitItems.dataset.kitImageUrl,
								_kitSellingPlan: kitItems.dataset.sellingPlan,
							},
						});
					}
				});
                
				if (dispenser) {
                    var dispenserIncludeQty = kitItemsArray.length * quantity;
                    if(foundBodyGuaShaTool){
                      dispenserIncludeQty = dispenserIncludeQty - 1;
                    }
                    
					items.push({
						id: dispenserInclude.dataset.dispenserKitId,
						quantity: dispenserIncludeQty,
						properties: {
							_kitHandle: `${kitItems.dataset.kitHandle}-delivery-every-${kitItems.dataset.sellingPlan}`,
							_kitTitle: kitItems.dataset.kitTitle,
							_kitPrice: parseInt(kitItems.dataset.kitPrice),
							_kitImageUrl: kitItems.dataset.kitImageUrl,
						},
					});
				}
			} else {
              if(purchaseTypeOneTimeCheckBox) {
                  	if (!purchaseTypeOneTimeCheckBox.checked) {
                     if(form.querySelector('[name="properties[Preorder]"]')){
                       items.push({
						id: useCustomRefillAndPumpLinkedProduct?useCustomRefillAndPumpLinkedProductID:form.querySelector('[name="id"]').value,
						quantity: form.querySelector('[name="quantity"]').value,
						selling_plan: sellingPlan,
						properties: {
							_sellingPlan: propertiesSubscription.dataset.sellingPlan,
                             Preorder: form.querySelector('[name="properties[Preorder]"]').value,
                             Bottle: dispenser && dispenserInclude.checked ? document.querySelector(".product-thumbnail_title-is-dispenser").innerHTML : ""
						},
					});
                     }else{ 
					items.push({
						id: useCustomRefillAndPumpLinkedProduct?useCustomRefillAndPumpLinkedProductID:form.querySelector('[name="id"]').value,
						quantity: form.querySelector('[name="quantity"]').value,
						selling_plan: sellingPlan,
						properties: {
							_sellingPlan: propertiesSubscription.dataset.sellingPlan,
                            Bottle: dispenser && dispenserInclude.checked ? document.querySelector(".product-thumbnail_title-is-dispenser").innerHTML : ""
						},
					});
                     }
				} else {
                     if(form.querySelector('[name="properties[Preorder]"]')){
                      items.push({
						id: useCustomRefillAndPumpLinkedProduct?useCustomRefillAndPumpLinkedProductID:form.querySelector('[name="id"]').value,
						quantity: form.querySelector('[name="quantity"]').value,
						selling_plan: sellingPlan,
                        properties: {
                             Preorder: form.querySelector('[name="properties[Preorder]"]').value,
                             Bottle: dispenser && dispenserInclude.checked ? document.querySelector(".product-thumbnail_title-is-dispenser").innerHTML : ""
						}
					});
                     }else{
					items.push({
						id: useCustomRefillAndPumpLinkedProduct?useCustomRefillAndPumpLinkedProductID:form.querySelector('[name="id"]').value,
						quantity: form.querySelector('[name="quantity"]').value,
						selling_plan: sellingPlan,
                        properties: {                        
                             Bottle: dispenser && dispenserInclude.checked ? document.querySelector(".product-thumbnail_title-is-dispenser").innerHTML : ""
						}
					});
                     }
				}
              } else {

                 if(form.querySelector('[name="properties[Preorder]"]')){
                  items.push({
						id: useCustomRefillAndPumpLinkedProduct?useCustomRefillAndPumpLinkedProductID:form.querySelector('[name="id"]').value,
						quantity: form.querySelector('[name="quantity"]').value,
						selling_plan: sellingPlan,
                        properties: {
                             Preorder: form.querySelector('[name="properties[Preorder]"]').value,
                             Bottle: dispenser && dispenserInclude.checked ? document.querySelector(".product-thumbnail_title-is-dispenser").innerHTML : ""
						}
					});
                 }else{
                	items.push({
						id: useCustomRefillAndPumpLinkedProduct?useCustomRefillAndPumpLinkedProductID:form.querySelector('[name="id"]').value,
						quantity: form.querySelector('[name="quantity"]').value,
						selling_plan: sellingPlan,
                       properties: {                        
                             Bottle: dispenser && dispenserInclude.checked ? document.querySelector(".product-thumbnail_title-is-dispenser").innerHTML : ""
						}
					});
                 }
              }
			

				if (dispenser && dispenserInclude.checked) {
					let item = {
						id: dispenserInclude.value,
						quantity: dispenser.querySelector('[name="dispenser quantity"]')
							.value,
					};
					items.push(item);
				}
			}
            items.forEach(function(item_obj){
              if(typeof item_obj.properties != "undefined"){
                var object = item_obj.properties;
                for (var key in object) {
                if (object.hasOwnProperty(key)) {
                if (object[key] === null || object[key] == "")
                delete object[key];
                }
                }
              }
            });

           if(freeBodyTool && !freeBodyToolInCart){
              let item = {
						id: freeBodyTool.value,
						quantity: 1,
					};
					items.push(item);
            }

            if(freeBodyToolForAll && !freeBodyToolInCartForAll){
              let item = {
						id: freeBodyToolForAll.value,
						quantity: 1,
					};
					items.push(item);
            }

            
			setTimeout(() => {
				addItem(items, true, true, 1200);
			}, 1);
		};

		form.addEventListener('submit', e => {

			e.preventDefault();
          formSubmitTrigger();

                  // let preventSubmit = false;
                  // let submitBtn = e.target.querySelector('[type="submit"]');
                  // if(submitBtn) {
                  // let submitBtnHasOutOfStockFlag = submitBtn.hasAttribute('data-reserve_stock_soldout_product');
                  // if(submitBtnHasOutOfStockFlag) {
                  // preventSubmit = true;
                  // }
                  // }
                  
                  // if(preventSubmit) {
                  // return false;
                  // } else {
                  // 
                  // }
		});

		form.addEventListener('submitTrigger', e => {
           
			e.preventDefault();

          formSubmitTrigger();
          
		});
	});

	// reload cart data on load
	reloadCartData();


	document.addEventListener("change", (event) => {
		//debugger;
if(event.target.classList.contains("cart-items-subscribe-select")){
 const select = event.target;
 const selectedOption =  select.options[select.selectedIndex];
 const key = selectedOption.getAttribute("data-key");
 const variantId = selectedOption.value;
 const quantity = selectedOption.getAttribute("data-quantity") * 1;
 const planID = selectedOption.getAttribute("data-plan-id") || "";
 const planText = selectedOption.getAttribute("data-plan-text") || "";


fetch('/cart/change.js', {
		method: 'POST',
		headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		},
			body: JSON.stringify({'id': key,'quantity': 0}),    
		})
		.then(response => {
		response.json();
		})
		.then(() => {
 				let formData = {
                   'items': [{
                    'id': variantId,
                    'quantity': quantity,
					'selling_plan':planID,
					'properties': planText != "" ? {"_sellingPlan":planText} : ""
                    }]
                  };
                    fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                      body: JSON.stringify(formData),    
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();
                   
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
		  })
                    .catch(error => {
                    console.error('Error:', error);
                    });			


}
});

	
};

const initBlogIndex = () => {
	if (document.querySelector('blog-pagination-next')) {
		let infiniteScroll = new InfiniteScroll('.blog-load-more', {
			path: '.blog-pagination-next',
			append: '.blog-post',
			button: '.blog-load-more-trigger',
			scrollThreshold: false,
			history: false,
		});

		infiniteScroll.on('last', function(body, path) {
			let loadMoreTrigger = document.querySelector('.blog-load-more-trigger');

			loadMoreTrigger.style.display = 'block';
			loadMoreTrigger.disabled = true;
			loadMoreTrigger.innerHTML = 'You’ve reached the end';
		});
	}
};

const initAccount = () => {
	// account gate
	const gateWrapper = document.querySelector('.account-gate-wrapper');

	if (gateWrapper) {
		const loginContent = gateWrapper.querySelector('.account-login');
		const registerContent = gateWrapper.querySelector('.account-register');
		const resetContent = gateWrapper.querySelector('.account-reset');
		const resetPasswordClose = document.querySelector(
			'.account-reset-password-close'
		);

		// account gate toggle
		document.addEventListener('click', e => {
			if (
				e.target.classList.contains('account-gate-open') ||
				e.target.closest('.account-gate-open')
			) {
				root.classList.add('account-gate-is-active');
				root.classList.remove('menu-is-active', 'minicart-is-active');
			}

			if (
				(root.classList.contains('account-gate-is-active') &&
					e.target.classList.contains('account-gate-close')) ||
				e.target.closest('.account-gate-close')
			) {
				root.classList.remove('account-gate-is-active');

				loginContent.classList.add('is-active');
				registerContent.classList.remove('is-active');
				resetContent.classList.remove('is-active');

				// remove hash from URL
				history.pushState(null, null, ' ');
			}

			if (
				e.target.classList.contains('account-register-open') ||
				e.target.closest('.account-register-open')
			) {
				loginContent.classList.remove('is-active');
				registerContent.classList.add('is-active');
				resetContent.classList.remove('is-active');
			}

			if (
				e.target.classList.contains('account-login-open') ||
				e.target.closest('.account-login-open')
			) {
				loginContent.classList.add('is-active');
				registerContent.classList.remove('is-active');
				resetContent.classList.remove('is-active');
			}

			if (
				e.target.classList.contains('account-register-close') ||
				e.target.closest('.account-register-close')
			) {
				loginContent.classList.add('is-active');
				registerContent.classList.remove('is-active');
				resetContent.classList.remove('is-active');
			}

			if (
				e.target.classList.contains('account-reset-password-open') ||
				e.target.closest('.account-reset-password-open')
			) {
				e.preventDefault();

				// update URL with hash
				history.pushState(null, null, '#recover');

				// assign active states
				root.classList.add('account-gate-is-active');
				loginContent.classList.remove('is-active');
				registerContent.classList.remove('is-active');
				resetContent.classList.add('is-active');

				// focus on email field
				document.querySelector('#account-recover-email').focus();
			}
		});

		if (resetPasswordClose) {
			resetPasswordClose.addEventListener('click', e => {
				e.preventDefault();

				// remove hash from URL
				history.pushState(null, null, ' ');

				// assign active states
				loginContent.classList.add('is-active');
				registerContent.classList.remove('is-active');
				resetContent.classList.remove('is-active');
			});
		}

		document.querySelectorAll('[action="/account"]').forEach(form => {
			form.addEventListener('submit', e => {
				let firstName = form.querySelector('#account-register-first-name');
				let lastName = form.querySelector('#account-register-last-name');
				let email = form.querySelector('#account-register-email');
				let password = form.querySelector('#account-register-password');

				let fieldCheck = field => {
					if (!field.value) {
						e.preventDefault();
						field.classList.add('is-error');
					} else {
						field.classList.remove('is-error');
					}
				};

				fieldCheck(firstName);
				fieldCheck(lastName);
				fieldCheck(password);

				// TODO: hook up account registeration with fetch
				// let formData = {
				// 	utf8: '✓',
				// 	form_type: 'create_customer',
				// 	'customer[first_name]': escape(firstName.value),
				// 	'customer[last_name]': escape(lastName.value),
				// 	'customer[email]': escape(email.value),
				// 	'customer[password]': escape(password.value).replace(/\+/g, '%2B'),
				// };
			});
		});

		// trigger account gate if url contains the hash
		if (location.hash == '#account') {
			root.classList.add('account-gate-is-active');
			root.classList.remove('menu-is-active', 'minicart-is-active');
		}

		if (location.hash == '#account-register') {
			root.classList.add('account-gate-is-active');
			root.classList.remove('menu-is-active', 'minicart-is-active');
			loginContent.classList.remove('is-active');
			registerContent.classList.add('is-active');
			resetContent.classList.remove('is-active');
		}

		// trigger password recovery form if url contains the hash
		if (location.hash == '#recover') {
			document.querySelector('.account-reset-password-open').click();
		}
	}

	const accountMenu = document.querySelector('.account-menu');

	if (accountMenu && window.innerWidth <= 900) {
		const menuLinks = accountMenu.querySelector('.menu-links');

		// setup HTML then append
		const select = document.createElement('select');

		menuLinks.querySelectorAll('li').forEach(item => {
			let option = document.createElement('option');

			option.innerHTML = item.innerText;
			option.setAttribute('data-url', item.querySelector('a').href);

			select.appendChild(option);
		});

		menuLinks.appendChild(select);
		menuLinks.classList.add('field', 'user-select-disable');

		select.addEventListener('change', () => {
			root.classList.add('is_leaving');
			window.location.href = select.options[select.selectedIndex].dataset.url;
		});
	}
};

// initiate site
window.addEventListener('DOMContentLoaded', event => {
	// execute pieces and components functions
	initItemQuantity();
	initFields();
	initFlickitySlider();
	initAccordion();

	// execute global and component functions
	initPageTransition();
	// initPageAnimation();
	initContentLayout();

	initCart();
	initAccount();

	initSectionProductSlider();
	initSectionTextOverlay();
	initQuickAddLayout();
	initIngredientCard();

	// execute page specific functions
	switch (root.id) {
		case 'product-single':
			productSingle();

		case 'blog-index':
			initBlogIndex();
			break;
	}

	// iframe fit vids
	reframe(
		`
			.hiw-media iframe,
			.overlay-media iframe,
			.content-layout iframe[src*="vimeo.com"],
			.content-layout iframe[src*="youtube.com"]
		`,
		'video-reframe'
	);

	// make visible .avoid-style-flash elements
	setTimeout(function() {
		document.querySelectorAll('.avoid-style-flash').forEach(el => {
			el.style.visibility = 'visible';
		});
	}, 400);

  var subscriptionDetailsTooltipLink = document.querySelector('.subscription-details-tooltip-link');
  var subscriptionDetailsTooltipContent = document.querySelector('.subscription-details-tooltip-content');
  if (subscriptionDetailsTooltipLink != null && subscriptionDetailsTooltipContent != null) {
    subscriptionDetailsTooltipLink.addEventListener("click", function(e) {
      if (subscriptionDetailsTooltipContent.classList.contains('show')) {
        subscriptionDetailsTooltipContent.classList.remove('show');
      } else {
        subscriptionDetailsTooltipContent.classList.add('show');
      }
    });

    document.addEventListener("click", function(e) {
      if (!e.target.closest('.subscription-details-tooltip-link') && !e.target.closest('.subscription-details-tooltip-content')) {
        subscriptionDetailsTooltipContent.classList.remove('show');
      }
    });
  }

  var cartSampleProducts = document.querySelector('.cart_sample_products');
  if (cartSampleProducts) {

    const sample_product_size = cartSampleProducts.querySelectorAll('.sample_product');

    if(sample_product_size.length > 4) {
    var cartSampleProductsFlkty = new Flickity( cartSampleProducts, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false
    });
  }
  }

     var cartUpsellProductReviews = document.querySelectorAll('.cart_upsell_product_reviews');
      if (cartUpsellProductReviews.length) {
        cartUpsellProductReviews.forEach(function (item) {
          var autopplaySpeed = item.getAttribute("data-autoplay") * 1;
          const cartUpsellProductReviewsFlkty = new Flickity(item, {
              pageDots: true,
              prevNextButtons: false,
              wrapAround: true,
              cellAlign: 'center',
              autoPlay:autopplaySpeed
          });
        });
      }

	  var cartUpsellProducts = document.querySelectorAll('.cart_upsell_products:not(.minicart_christmas_gifts--cart_upsell_products)');
      if (cartUpsellProducts.length) {
        cartUpsellProducts.forEach(function (item) {
          var autopplaySpeed = item.getAttribute("data-autoplay") * 1;
          const cartUpsellProductsFlkty = new Flickity(item, {
              pageDots: true,
              prevNextButtons: false,
              wrapAround: true,
              autoPlay:autopplaySpeed
          });
        });
      }

});


document.addEventListener('click', function(e){
  	let el = e.target;
    if(el.classList.contains('product-ingredients-collapse-button') || el.closest('.product-ingredients-collapse-button')) {
      if(!el.classList.contains('product-ingredients-collapse-button')) {
      	el = el.closest('.product-ingredients-collapse-button');
      }

      e.preventDefault();
      e.stopPropagation();
      
      let container = document.querySelector('#product-ingredients');
      if(container) {

        
    if (!container.classList.contains('active')) {
      
      container.classList.add('active');
      container.style.height = 'auto';

      var height = container.clientHeight + 'px';

      container.style.height = '0px';

      setTimeout(function () {
        container.style.height = height;
      }, 0);
      
    } else {
      
      container.style.height = '0px';

      container.addEventListener('transitionend', function () {
        container.classList.remove('active');
      }, {
        once: true
      });
      
    }
        
        
      }
    }
});

document.addEventListener('click', function(e){
  	let el = e.target;
    if(el.classList.contains('add_upsell_product') || el.closest('.add_upsell_product')) {
      if(!el.classList.contains('add_upsell_product')) {
      	el = el.closest('.add_upsell_product');
      }

      e.preventDefault();
      e.stopPropagation();

      let items = [];
      let itemId = el.getAttribute('data-id') * 1;
      let sellingPlanId = el.getAttribute('data-subscription');
      if(sellingPlanId != ""){
        sellingPlanId = sellingPlanId*1;
      }

      items.push({
						id: itemId,
						quantity: 1,
						selling_plan: sellingPlanId,
                        properties: {                        
                             Bottle: el.getAttribute("data-property")
						}
					});
      let addDispenser = el.getAttribute('data-add-dispenser');
      if(addDispenser == "true"){
      items.push({
						id: document.body.getAttribute("data-dispenser-id"),
						quantity: 1,
						selling_plan: "",
					});
      }
      	setTimeout(() => {
          addItem(items, true, true, el.closest(".framer-product-with-image-section-upsell-products")?1200:0);
    	}, 1);

      
    }
});

document.addEventListener('change', function(e){
  	const el = e.target;
    if(el.classList.contains('add_sample_product_input')) {
     const parentEl = el.closest('.cart_sample_row');
      if(parentEl) {
        const checkedLimit = parentEl.getAttribute('data-free_sample_qty') * 1;
        const checkedInputsSize = parentEl.querySelectorAll('.add_sample_product_input:checked').length;
        const notCheckedInputs = parentEl.querySelectorAll('.add_sample_product_input:not(:checked)');


        if(notCheckedInputs.length) {
            for(const input of notCheckedInputs) {
               if(checkedLimit <= checkedInputsSize) {
              input.disabled = true;
            } else {
              input.removeAttribute('disabled');
            }
          }
        }
      }
    }
});


document.addEventListener('click', function(e){
  	let el = e.target;
    if(el.classList.contains('minicart_footer_checkout_btn') || el.closest('.minicart_footer_checkout_btn')) {
      if(!el.classList.contains('minicart_footer_checkout_btn')) {
      	el = el.closest('.minicart_footer_checkout_btn');
      }

      const sample_checkedInputs = document.querySelectorAll('.add_sample_product_input:checked');

      if(sample_checkedInputs.length) {
        
      
      e.preventDefault();
      e.stopPropagation();

      let items = [];

       for(const input of sample_checkedInputs)  {

        const already_in_cart = input.getAttribute('data-already-in-cart');

         if(already_in_cart == 'false') {
          const itemId = input.value * 1;
          items.push({
                  id: itemId,
                  quantity: 1,
              });
         }
       }
    
  console.log(items);

        if(items.length) {
        	setTimeout(() => {
          addItem(items, true, true, 0, function  () {
         
            window.location.href = el.href;
          });
    	}, 1);
        } else {
             window.location.href = el.href;
        }

      }
    }
});

var productInfoAddtoCartButton = document.querySelector(".product-info-add-to-cart-button");
if(productInfoAddtoCartButton){
  productInfoAddtoCartButton.addEventListener("click", function(){
    var variantID = this.getAttribute("data-variant-id");
    let items = [];
     items.push({
						id: variantID,
						quantity: 1,
						properties: {
                             Bottle: document.querySelector(".product-thumbnail_title-is-dispenser") ? document.querySelector(".product-thumbnail_title-is-dispenser").innerHTML : ""
						},
					});


					let item = {
						id: document.body.getAttribute("data-dispenser-id"),
						quantity: 1,
					};
					items.push(item);

    setTimeout(() => {
          addItem(items, true, true, 1200);
    	}, 1);
  });

}

  document.addEventListener("change", function(e){

	if(e.target.classList.contains("minicart_christmas_gifts_grid_item_trigger")){
	e.target.setAttribute("disabled", true);
	var variantID = e.target.getAttribute("data-variant-id");
	if(e.target.checked){	
    let items = [];
     items.push({
					id: variantID,
						quantity: 1,
					});
	if(e.target.getAttribute("type") == "radio"){
		debugger;
		var uncheckedInput = false;
		var minicartChristmasGiftsGridWrapper = e.target.closest(".minicart_christmas_gifts_grid");
		minicartChristmasGiftsGridWrapper.querySelectorAll(".minicart_christmas_gifts_grid_item_trigger").forEach((input) => {
			if(input.checked == false){
				uncheckedInput = input;
			}
		});

		if(uncheckedInput){
			var variantIDforRemove = uncheckedInput.getAttribute("data-variant-id");
			fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                      body: '{"updates":{"'+variantIDforRemove+'":0}}',    
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
		}
	}				
    setTimeout(() => {
          addItem(items, true, true, 1200);
    	}, 200);
	}else{
		fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    },
                      body: '{"updates":{"'+variantID+'":0}}',    
                    })
                    .then(response => {
                    response.json();
                    })
                    .then(() => {
                    reloadCartData();
                    reloadCartItems();                 
                    })
                    .catch(error => {
                    console.error('Error:', error);
                    });
  	}
  }
  });
document.addEventListener("DOMContentLoaded", function(event) { 
  // var productIngredientsItems = document.querySelectorAll('.product-ingredients-section-items-list-item');
  // if (productIngredientsItems.length) {
  //   productIngredientsItems.forEach(function(item){
  //     item.addEventListener('mouseenter', function(e){
  //       productIngredientsItems.forEach(function(el){
  //         el.classList.remove('active');
  //       });
  //       this.classList.add('active');
  //       var id = this.getAttribute('data-id');
  //       var itemsDescriptions = this.closest('.product-ingredients-section').querySelectorAll('.product-ingredients-section-image-text');
  //       if (itemsDescriptions.length) {
  //         itemsDescriptions.forEach(function(el){
  //           if (el.getAttribute('data-id') == id) {
  //             el.classList.add('active');
  //           } else {
  //             el.classList.remove('active');
  //           }
  //         });
  //       }
  //     });
  //   });
  // }

  var productIngredientsLink = document.querySelector('.product-ingredients-section-link .link');
  if (productIngredientsLink != null) {
    productIngredientsLink.addEventListener('click', function(e){
      this.classList.toggle('active');
      this.closest('.product-ingredients-section-link').classList.toggle('active');
      var productIngredientsList = this.closest('.product-ingredients-section-items').querySelector('.product-ingredients-section-items-list');
      var productIngredientsAlltext = this.closest('.product-ingredients-section-items').querySelector('.product-ingredients-section-items-all-text');
      if (productIngredientsList != null && productIngredientsAlltext != null) {
        if (this.classList.contains('active')) {
          productIngredientsAlltext.classList.add('active');
          productIngredientsList.classList.remove('active');
        } else {
          productIngredientsAlltext.classList.remove('active');
          productIngredientsList.classList.add('active');
        }
      }
    });
  }

  var productIngredientsSectionKitProducts = document.querySelectorAll('.product-ingredients-section-items-kit-products-item');
  if (productIngredientsSectionKitProducts.length) {
    productIngredientsSectionKitProducts.forEach(function(item){
      item.addEventListener('click', function(e){
        productIngredientsSectionKitProducts.forEach(function(el){
          el.classList.remove('active');
        });
        this.classList.add('active');
        var id = this.getAttribute('data-id');
        var productIngredientsSectionKitProductsIngredients = this.closest('.product-ingredients-section-items').querySelectorAll('.product-ingredients-section-items-all-text');
        if (productIngredientsSectionKitProductsIngredients.length) {
          productIngredientsSectionKitProductsIngredients.forEach(function(el){
            if (el.getAttribute('data-id') == id) {
              el.classList.add('active');
            } else {
              el.classList.remove('active');
            }
          });
        }
      });
    });
  }

   var hiwSchemaSection = document.querySelector('.hiw-schema-section');
  var hiwSchemaSectionTextBlock1 = document.querySelector('.hiw-schema-section .hiw-schema-section-grid-item.item-1 .hiw-schema-section-grid-item-text');
  var hiwSchemaSectionTextBlock2 = document.querySelector('.hiw-schema-section .hiw-schema-section-grid-item.item-2 .hiw-schema-section-grid-item-text');
  var hiwSchemaSectionTextBlock3 = document.querySelector('.hiw-schema-section .hiw-schema-section-grid-item.item-3 .hiw-schema-section-grid-item-text');
  var announcementHeight = 0;
  if (document.querySelector('.global-announcement') != null) {
    announcementHeight = document.querySelector('.global-announcement').offsetHeight;
  }

  var headerHeight = 0;
  if (document.querySelector('.global-header') != null) {
    headerHeight = document.querySelector('.global-header').offsetHeight;
  }

  if (hiwSchemaSectionTextBlock1 != null) {
    if (hiwSchemaSection.getBoundingClientRect().top - announcementHeight - headerHeight < 90) {
      hiwSchemaSectionTextBlock1.classList.add('show');
    } else {
      hiwSchemaSectionTextBlock1.classList.remove('show');
    }
  }

  if (hiwSchemaSectionTextBlock2 != null) {
    if (hiwSchemaSection.getBoundingClientRect().top - announcementHeight - headerHeight < -100) {
      if (hiwSchemaSectionTextBlock1 != null) {
        hiwSchemaSectionTextBlock1.classList.remove('show');
      }
      hiwSchemaSectionTextBlock2.classList.add('show');
    } else {
      hiwSchemaSectionTextBlock2.classList.remove('show');
    }
  }

  if (hiwSchemaSectionTextBlock3 != null) {
    if (hiwSchemaSection.getBoundingClientRect().top - announcementHeight - headerHeight < -190) {
      if (hiwSchemaSectionTextBlock2 != null) {
        hiwSchemaSectionTextBlock2.classList.remove('show');
      }
      hiwSchemaSectionTextBlock3.classList.add('show');
    } else {
      hiwSchemaSectionTextBlock3.classList.remove('show');
    }
  }
  
  if (hiwSchemaSection != null) {
    window.addEventListener("scroll", function () {
      if (hiwSchemaSectionTextBlock1 != null) {
        if (hiwSchemaSection.getBoundingClientRect().top - announcementHeight - headerHeight < 90) {
          hiwSchemaSectionTextBlock1.classList.add('show');
        } else {
          hiwSchemaSectionTextBlock1.classList.remove('show');
        }
      }

      if (hiwSchemaSectionTextBlock2 != null) {
        if (hiwSchemaSection.getBoundingClientRect().top - announcementHeight - headerHeight < -100) {
          if (hiwSchemaSectionTextBlock1 != null) {
            hiwSchemaSectionTextBlock1.classList.remove('show');
          }
          hiwSchemaSectionTextBlock2.classList.add('show');
        } else {
          hiwSchemaSectionTextBlock2.classList.remove('show');
        }
      }

      if (hiwSchemaSectionTextBlock3 != null) {
        if (hiwSchemaSection.getBoundingClientRect().top - announcementHeight - headerHeight < -190) {
          if (hiwSchemaSectionTextBlock2 != null) {
            hiwSchemaSectionTextBlock2.classList.remove('show');
          }
          hiwSchemaSectionTextBlock3.classList.add('show');
        } else {
          hiwSchemaSectionTextBlock3.classList.remove('show');
        }
      }
    });
  }
});

$(document).ready(function(){
  $('.product-thumbnail_title--wrapper.custom-product-mobile-dropdown-button').on('click', function() {
    if (window.innerWidth < 770) {
      // $('.custom-product-mobile-dropdown-body').slideUp();
      // $('.custom-product-mobile-dropdown-button').removeClass('hide');
    //   $(this).closest('.custom-product-mobile-dropdown').find('.custom-product-mobile-dropdown-body').slideToggle();
      $(this).addClass('hide');
    }
  })

  $(window).on('click', function(e) {
    if (window.innerWidth < 770) {
      if (!e.target.closest('.custom-product-mobile-dropdown')) {
        // $('.product-thumbnail_title--wrapper.custom-product-mobile-dropdown-button + .custom-product-mobile-dropdown-body').slideUp();
        $('.product-thumbnail_title--wrapper.custom-product-mobile-dropdown-button').removeClass('hide');
      }
    }
  });

  const landingAboutSection = document.querySelectorAll('.landing-page-about-us-section .product-about-us-section-grid');
  if (landingAboutSection.length) {
	landingAboutSection.forEach(function(item) {
		const landingAboutSectionSliderFlkty = new Flickity(item, {
			pageDots: true,
			prevNextButtons: true,
			wrapAround: false,
			cellAlign: 'center',
			watchCSS: true
		});
	});
  }

});


var CountdownTimer = class extends HTMLElement {
  connectedCallback() {
    
    const _this = this;

    let countdown_timerEl = this.querySelector(".countdown_timer");
    if(countdown_timerEl) {
      const dateStr = _this.getAttribute('data-time');
      
      let countDownDate = new Date(dateStr).getTime();
      if(dateStr == '0') {
         countDownDate = new Date().setHours(23,59,59,999);
      }

      const timerDaysBlock = this.querySelector('.timer-days');
      const timerDaysElem = this.querySelector('.timer-days .timer-value');
      const timerDaysLabelElem = this.querySelector('.timer-days .timer-label');

      const timerHoursBlock = this.querySelector('.timer-hours');
      const timerHoursElem = this.querySelector('.timer-hours .timer-value');
       const timerHoursLabelElem = this.querySelector('.timer-hours .timer-label');

      const timerMinutesBlock = this.querySelector('.timer-minutes');
      const timerMinutesElem = this.querySelector('.timer-minutes .timer-value');
      const timerMinutesLabelElem = this.querySelector('.timer-minutes .timer-label');

      const timerSecondsBlock = this.querySelector('.timer-seconds');
      const timerSecondsElem = this.querySelector('.timer-seconds .timer-value');
      const timerSecondsLabelElem = this.querySelector('.timer-seconds .timer-label');
      

        //let now = new Date().getTime();
        let tempDate = new Date();
        let timezoneOffset = tempDate.getTimezoneOffset();
        let estOffset = -480;
        let now = new Date(tempDate.getTime() + (estOffset + timezoneOffset) * 60 * 1000);
        let distance = countDownDate - now;

      let x = setInterval(function() {
        //let now = new Date().getTime();
        let tempDate = new Date();
        let timezoneOffset = tempDate.getTimezoneOffset();
        console.log(timezoneOffset);
        let estOffset = -480;
        let now = new Date(tempDate.getTime() + (estOffset + timezoneOffset) * 60 * 1000);
        console.log(now);
        let distance = countDownDate - now;
        console.log(distance)
        if(distance <= 0) {
          
            clearInterval(x);
            if(_this) {
              _this.style.display = 'none';

              if(_this.closest('.timer-bar-section-wrapper')) {
                _this.closest('.timer-bar-section-wrapper').classList.add('hide');
              }

              if(_this.closest('.announcement-text').querySelector('.announcement-timer-end-text')) {
                _this.closest('.announcement-text').querySelector('.announcement-timer-end-text').classList.add('show');;
              }
            
            }
          
        }


        if(distance >= 0) {
          // let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor(distance / (1000 * 60 * 60));
          let minutes = Math.floor(distance / (1000 * 60));
          let seconds = Math.floor(distance / (1000));

        

          // timerDaysElem.innerHTML = days;
          timerHoursElem.innerHTML = hours;
          timerMinutesElem.innerHTML = minutes;
          timerSecondsElem.innerHTML = seconds;

          timerMinutesBlock.style.display = 'none';
          timerSecondsBlock.style.display = 'none';

          if (hours == 0) {
            timerMinutesBlock.style.display = 'block';
            timerSecondsBlock.style.display = 'none';
            timerHoursBlock.style.display = 'none';
          }else{
            timerHoursBlock.style.display = 'block';
          }
          if (hours == 0 && minutes == 0) {
            timerMinutesBlock.style.display = 'none';
            timerSecondsBlock.style.display = 'block';
            timerHoursBlock.style.display = 'none';
          }

          // if (days == 0) {
          //   timerDaysBlock.style.display = 'none';
          // }
          // if (days == 0 && hours == 0) {
          //   timerHoursBlock.style.display = 'none';
          // }
          // if (days == 0 && hours == 0 && minutes == 0) {
          //   timerMinutesBlock.style.display = 'none';
          // }
        }
      },1000);

        if(distance <= 0) {
          
            clearInterval(x);
            if(_this) {
              _this.style.display = 'none';

              if(_this.closest('.timer-bar-section-wrapper')) {
                _this.closest('.timer-bar-section-wrapper').classList.add('hide');;
              }

              if(_this.closest('.announcement-text').querySelector('.announcement-timer-end-text')) {
                _this.closest('.announcement-text').querySelector('.announcement-timer-end-text').classList.add('show');;
              }
            }
          
        }


        if(distance >= 0) {
          // let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor(distance / (1000 * 60 * 60));
          let minutes = Math.floor(distance / (1000 * 60));
          let seconds = Math.floor(distance / (1000));

        

          // timerDaysElem.innerHTML = days;
          timerHoursElem.innerHTML = hours;
          timerMinutesElem.innerHTML = minutes;
          timerSecondsElem.innerHTML = seconds;

          timerMinutesBlock.style.display = 'none';
          timerSecondsBlock.style.display = 'none';

          if (hours == 0) {
            timerMinutesBlock.style.display = 'block';
            timerSecondsBlock.style.display = 'none';
            timerHoursBlock.style.display = 'none';
          }else{
            timerHoursBlock.style.display = 'block';
          }
          if (hours == 0 && minutes == 0) {
            timerMinutesBlock.style.display = 'none';
            timerSecondsBlock.style.display = 'block';
            timerHoursBlock.style.display = 'none';
          }

          // if (days == 0) {
          //   timerDaysBlock.style.display = 'none';
          // }
          // if (days == 0 && hours == 0) {
          //   timerHoursBlock.style.display = 'none';
          // }
          // if (days == 0 && hours == 0 && minutes == 0) {
          //   timerMinutesBlock.style.display = 'none';
          // }
        }
      
      

    }

  }

};
if (!window.customElements.get("countdown-timer")) {
  window.customElements.define("countdown-timer", CountdownTimer);
}

document.addEventListener("DOMContentLoaded", function(event) { 
	var headerMegaLinks = document.querySelectorAll('.mein-menu-link');
	var headerMegaMenus = document.querySelectorAll('.header-mega-menu');
	var mainHeader = document.querySelector('.global-header');
	var mainMenuSearchLink = document.querySelector('.mein-menu-link.main-menu-search-link');
	var mainMenuSearchBar = document.querySelector('.global-menu-searchbar');
	var mainMenuSearchBarClose = document.querySelector('.d-menu-search-close');
	if (headerMegaLinks.length) {
		headerMegaLinks.forEach(function(item) {
			item.addEventListener("mouseenter", function(e) {
				if (headerMegaMenus.length) {
					headerMegaMenus.forEach(function(el) {
						if (item.getAttribute('data-mega-id') == el.getAttribute('data-mega-id')) {
							el.style.maxHeight = el.scrollHeight + "px";
							if (mainMenuSearchBar != null) {
								mainMenuSearchBar.classList.remove('show');
							}
						} else {
							el.style.maxHeight = null;
						}
					});
				}
			});
		});
	}

	if (mainHeader != null) {
		mainHeader.addEventListener("mouseleave", function(e) {
			if (headerMegaMenus.length) {
				headerMegaMenus.forEach(function(el) {
					el.style.maxHeight = null;
				});
			}
		});
	}

	if (mainMenuSearchLink != null) {
		mainMenuSearchLink.addEventListener("click", function(event) {
			event.preventDefault();
			if (mainMenuSearchBar != null) {
				mainMenuSearchBar.classList.toggle('show');
			}
		});
	}

	if (mainMenuSearchBarClose != null) {
		mainMenuSearchBarClose.addEventListener("click", function(event) {
			event.preventDefault();
			if (mainMenuSearchBar != null) {
				mainMenuSearchBar.classList.remove('show');
			}
		});
	}
});

class MegaMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var bodySlider = this.querySelector('.header-mega-menu-body');
	var categories = this.querySelectorAll('.header-mega-menu-categories-item');
	var bodySliderItems = this.querySelectorAll('.header-mega-menu-body .swiper-slide');
	var imagesSlider = this.querySelectorAll('.header-mega-menu-images-slider.use-slider');
	if (bodySlider != null) {
		var swiper = new Swiper(bodySlider, {
			loop: true,
			slidesPerView: 1,
  			spaceBetween: 20
		});
	}

	if (categories.length) {
		categories.forEach(function(item) {
			item.addEventListener("mouseenter", function(e) {
				if (bodySliderItems.length) {
					bodySliderItems.forEach(function(el) {
						if (item.getAttribute('data-subitem-id') == el.getAttribute('data-subitem-id')) {
							swiper.slideTo(+el.getAttribute('data-swiper-slide-index'));
							categories.forEach(function(elem) {
								elem.classList.remove('active');
							});
							item.classList.add('active');
						}
					});
				}
			});
		});
	}

	if (imagesSlider.length) {
		imagesSlider.forEach(function(item) {
			var swiperI = new Swiper(item, {
				loop: false,
				slidesPerView: 5,
				spaceBetween: 20,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			});
		});
	}
  }
}

customElements.define("mega-menu", MegaMenu);

class HeaderMobileMenu extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    var bodySlider = this.querySelector('.mobile-menu-body');
	var categories = this.querySelectorAll('.header-mobile-menu-categories-header-item');
	var bodySliderItems = this.querySelectorAll('.mobile-menu-body .swiper-slide');
	if (bodySlider != null) {
		var swiper = new Swiper(bodySlider, {
			loop: true,
			slidesPerView: 1,
  			spaceBetween: 20,
			autoHeight: true
		});
	}

	if (categories.length) {
		categories.forEach(function(item) {
			item.addEventListener("click", function(e) {
				if (bodySliderItems.length) {
					bodySliderItems.forEach(function(el) {
						if (item.getAttribute('data-subitem-id') == el.getAttribute('data-subitem-id')) {
							swiper.slideTo(+el.getAttribute('data-swiper-slide-index'));
							categories.forEach(function(elem) {
								elem.classList.remove('active');
							});
							item.classList.add('active');
						}
					});
				}
			});
		});
	}

	var dropdownButtons = this.querySelectorAll('.mobile-menu-dropdown-heading');
	if (dropdownButtons != null) {
		dropdownButtons.forEach(function(item) {
			item.addEventListener("click", function(e) {
				this.classList.toggle('active');

				var accordionPanel = this.nextElementSibling;
				if (accordionPanel.style.maxHeight) {
					accordionPanel.style.maxHeight = null;
				} else {
					accordionPanel.style.maxHeight = accordionPanel.scrollHeight + "px";
				}
			});
		});
	}
  }
}

customElements.define("header-mobile-menu", HeaderMobileMenu);

document.addEventListener("touchstart", function(event) { 
	if (event.target.closest('.product-card .quick-add-toggle')) {
		event.target.closest('.product-card .quick-add-toggle').classList.add('is-touched');
		setTimeout(function () {
			event.target.closest('.product-card .quick-add-toggle').classList.remove('is-touched');
		}, 2000);
	}
});



var requestIdleCallback =
  typeof window.requestIdleCallback == "function" ? window.requestIdleCallback : setTimeout;

var reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");

function prefersReducedMotion() {
  return reducedMotion.matches;
}
class Component extends HTMLElement {
  /**
   * An object holding references to child elements with `ref` attributes.
   *
   * @type {RefsType<T>}
   */
  refs = /** @type {RefsType<T>} */ ({});

  /**
   * An array of required refs. If a ref is not found, an error will be thrown.
   *
   * @type {string[] | undefined}
   */
  requiredRefs;

  /**
   * Gets the root node of the component, which is either its shadow root or the component itself.
   *
   * @returns {(ShadowRoot | Component<T>)[]} The root nodes.
   */
  get roots() {
    return this.shadowRoot ? [this, this.shadowRoot] : [this];
  }

  /**
   * Called when the element is connected to the document's DOM.
   *
   * Initializes event listeners and refs.
   */
  connectedCallback() {
	debugger;
    registerEventListeners();

    this.#updateRefs();

    requestIdleCallback(() => {
      for (const root of this.roots) {
        this.#mutationObserver.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["ref"],
          attributeOldValue: true,
        });
      }
    });
  }

  /**
   * Called when the element is re-rendered by the Section Rendering API.
   */
  updatedCallback() {
    this.#mutationObserver.takeRecords();
    this.#updateRefs();
  }

  /**
   * Called when the element is disconnected from the document's DOM.
   *
   * Disconnects the mutation observer.
   */
  disconnectedCallback() {
    this.#mutationObserver.disconnect();
  }

  /**
   * Updates the `refs` object by querying all descendant elements with `ref` attributes and storing references to them.
   *
   * This method is called to keep the `refs` object in sync with the DOM.
   */
  #updateRefs() {
	debugger;
    const refs = /** @type any */ ({});
    const elements = this.roots.reduce((acc, root) => {
      for (const element of root.querySelectorAll("[ref]")) {
        if (!this.#isDescendant(element)) continue;
        acc.add(element);
      }

      return acc;
    }, /** @type {Set<Element>} */ (new Set()));

    for (const ref of elements) {
      const refName = ref.getAttribute("ref") ?? "";
      const isArray = refName.endsWith("[]");
      const path = isArray ? refName.slice(0, -2) : refName;

      if (isArray) {
        const array = Array.isArray(refs[path]) ? refs[path] : [];

        array.push(ref);
        refs[path] = array;
      } else {
        refs[path] = ref;
      }
    }

    if (this.requiredRefs?.length) {
      for (const ref of this.requiredRefs) {
        if (!(ref in refs)) {
          throw new MissingRefError(ref, this);
        }
      }
    }

    this.refs = /** @type {RefsType<T>} */ (refs);
  }

  /**
   * MutationObserver instance to observe changes in the component's DOM subtree and update refs accordingly.
   *
   * @type {MutationObserver}
   */
  #mutationObserver = new MutationObserver((mutations) => {
    if (
      mutations.some(
        (m) =>
          (m.type === "attributes" && this.#isDescendant(m.target)) ||
          (m.type === "childList" && [...m.addedNodes, ...m.removedNodes].some(this.#isDescendant))
      )
    ) {
      this.#updateRefs();
    }
  });

  /**
   * Checks if a given node is a descendant of this component.
   *
   * @param {Node} node - The node to check.
   * @returns {boolean} True if the node is a descendant of this component.
   */
  #isDescendant = (node) => getClosestComponent(getAncestor(node)) === this;
}

class MarqueeComponent extends Component {
  requiredRefs = ["inner"];

  #resizeObserver;
  #scrollStop = null;
  #inViewStop = null;
  #intersectionObserver = null;
  #previousWidth = 0;

  static #PAUSE_OBSERVER_MARGIN = "0px 0px 50px 0px";
  static #MIN_COPIES = 5;
  static #COPY_WIDTH_ESTIMATE = 200;
  static #DURATION_MULTIPLIER = 33;
  static #DURATION_MAX_RATIO = 2.5;
  static #DEFAULT_DURATION = "20s";
  static #DEFAULT_PARALLAX = 0.55;
  static #RESIZE_DEBOUNCE = 200;

  connectedCallback() {

    if (prefersReducedMotion()) return;
	this.refs.inner = this.querySelector('[ref="inner"]')
    this.isRTL = false;

    // Init immediately to prevent layout shift when scrolling
    // Defer slightly to avoid blocking page load
    if (typeof requestIdleCallback !== "undefined") {
      requestIdleCallback(
        () => {
          this.#init();
        },
        { timeout: 1000 }
      );
    } else {
      // Fallback: use setTimeout for browsers without requestIdleCallback
      setTimeout(() => {
        this.#init();
      }, 100);
    }
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  #init() {
		//debugger;
    const { inner } = this.refs;
    if (!inner) return;

    const item = inner.firstElementChild;
    if (!item) return;

    // Defer all initialization to avoid force reflow during page load
    requestAnimationFrame(() => {
      // Batch all layout reads
      const height = this.offsetHeight;
      const isRotated = this.classList.contains("marquee--rotated");
      const childWidth = this.#getChildWidthSync(inner);
      const parentWidth = this.#getParentWidthSync();

      // Perform non-layout operations
      item.classList.add("animate");

      // Set animation duration with cached values
      this.#setAnimationDurationWithValues(childWidth, parentWidth);

      // Set height and rotate offset with cached values
      this.style.setProperty("--block-height", `${height}px`);
      if (isRotated) {
        this.#setRotateOffsetWithHeight(height);
      } else {
        this.style.setProperty("--offset", "0px");
      }

      this.#adjustItemCount();
      this.#previousWidth = parentWidth;

      if (this.parallax) {
        this.#initParallax();
        requestAnimationFrame(() => {
          this.#adjustItemCount();
        });
      } else {
        this.#initPauseObserver();
      }

      this.#setupResizeObserver();
    });
  }

  #getChildWidthSync(inner) {
    const item = inner?.firstElementChild;
    if (!item) return 1;
    const rect = item.getBoundingClientRect();
    return rect.right - rect.left;
  }

  #getParentWidthSync() {
    const rect = this.getBoundingClientRect();
    return rect.right - rect.left;
  }

  #setAnimationDurationWithValues(childWidth, parentWidth) {
    const liquidDuration = this.duration;
    if (liquidDuration && liquidDuration > 0) {
      this.style.setProperty("--duration", `${liquidDuration}s`);
      return;
    }

    if (childWidth > 0 && parentWidth > 0) {
      const ratio = Math.ceil(childWidth / parentWidth);
      const defaultSpeed = 16;
      const duration =
        (MarqueeComponent.#DURATION_MULTIPLIER - defaultSpeed) * Math.min(MarqueeComponent.#DURATION_MAX_RATIO, ratio);
      this.style.setProperty("--duration", `${duration}s`);
    } else {
      this.style.setProperty("--duration", MarqueeComponent.#DEFAULT_DURATION);
    }
  }

  #cleanup() {
    this.#resizeObserver?.disconnect();
    window.removeEventListener("resize", this.#handleResize);
    this.#intersectionObserver?.disconnect();
    this.#inViewStop?.();
    this.#scrollStop?.();
    this.#intersectionObserver = null;
    this.#inViewStop = null;
    this.#scrollStop = null;
  }

  #setAnimationDuration() {
    const liquidDuration = this.duration;
    if (liquidDuration && liquidDuration > 0) {
      this.style.setProperty("--duration", `${liquidDuration}s`);
      return;
    }

    const childWidth = this.childElementWidth;
    const parentWidth = this.parentWidth;

    if (childWidth > 0 && parentWidth > 0) {
      const ratio = Math.ceil(childWidth / parentWidth);
      const defaultSpeed = 16;
      const duration =
        (MarqueeComponent.#DURATION_MULTIPLIER - defaultSpeed) * Math.min(MarqueeComponent.#DURATION_MAX_RATIO, ratio);
      this.style.setProperty("--duration", `${duration}s`);
    } else {
      this.style.setProperty("--duration", MarqueeComponent.#DEFAULT_DURATION);
    }
  }

  #adjustItemCount(resetAll = false) {
    const { inner } = this.refs;
    if (!inner) return;

    const currentCount = inner.children.length;
    if (currentCount === 0) return;

    const originalItem = inner.firstElementChild;
    if (!originalItem) return;

    if (resetAll && currentCount > 1) {
      while (inner.children.length > 1) {
        inner.lastElementChild?.remove();
      }
    }

    if (inner.children.length === 1) {
      const conservativeCount = Math.max(
        MarqueeComponent.#MIN_COPIES,
        Math.ceil(window.innerWidth / MarqueeComponent.#COPY_WIDTH_ESTIMATE) + 2
      );
      // Batch DOM operations to reduce layout shifts
      // Use DocumentFragment to batch appends
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < conservativeCount - 1; i++) {
        const clone = originalItem.cloneNode(true);
        this.#disableFocusableElements(clone);
        clone.setAttribute("aria-hidden", "true");
        clone.classList.add("animate");
        fragment.appendChild(clone);
      }
      inner.appendChild(fragment);
      // Handle images after DOM update to prevent flicker
      requestAnimationFrame(() => {
        inner.querySelectorAll(".marquee__items:not(:first-child) .media").forEach((media) => {
          const img = media.querySelector("img.media__image");
          if (img && img.complete && img.naturalWidth > 0) {
            media.classList.remove("loading");
            if (img.classList.contains("loading")) {
              img.classList.remove("loading");
              img.classList.add("loaded");
            }
          }
        });
      });
    }

    const exactCount = this.#calculateNumberOfCopies();
    const finalCount = inner.children.length;

    if (exactCount > finalCount) {
      this.#addRepeatedItems(exactCount - finalCount, originalItem);
    } else if (exactCount < finalCount) {
      const itemsToRemove = Math.min(finalCount - exactCount, finalCount - 1);
      this.#removeRepeatedItems(itemsToRemove);
    }

    if (!this.hasAttribute("data-duration")) {
      this.#setAnimationDuration();
    }
  }

  #addRepeatedItems(numberOfCopies, templateItem = null) {
    const { inner } = this.refs;
    if (!inner) return;

    const item = templateItem || inner.firstElementChild;
    if (!item) return;

    for (let i = 0; i < numberOfCopies; i++) {
      this.#cloneItem(item, inner);
    }
  }

  #removeRepeatedItems(numberOfCopies) {
    const { inner } = this.refs;
    if (!inner) return;

    for (let i = 0; i < numberOfCopies; i++) {
      inner.lastElementChild?.remove();
    }
  }

  #cloneItem(item, container) {
    const clone = item.cloneNode(true);
    this.#disableFocusableElements(clone);
    clone.setAttribute("aria-hidden", "true");
    clone.classList.add("animate");
    container.appendChild(clone);

    // Handle images in cloned items to prevent flicker
    // Only remove loading class if images are already loaded
    clone.querySelectorAll(".media").forEach((media) => {
      const img = media.querySelector("img.media__image");
      if (img && img.complete && img.naturalWidth > 0) {
        // Image is already loaded, safe to remove loading class
        media.classList.remove("loading");
        if (img.classList.contains("loading")) {
          img.classList.remove("loading");
          img.classList.add("loaded");
        }
      }
      // If image is not loaded yet, keep loading class to prevent flicker
      // responsive-image will handle removing it when image loads
    });
  }

  #getFocusableElements(wrapperEl) {
    const focusableSelectors = "a[href], button:enabled, [tabindex]:not([tabindex^='-'])";
    const focusableElements = wrapperEl.querySelectorAll(focusableSelectors);

    return focusableElements;
  }

  #disableFocusableElements(wrapperEl) {
    const focusableElements = this.#getFocusableElements(wrapperEl);

    focusableElements &&
      focusableElements.forEach((el) => {
        el.setAttribute("tabindex", "-1");
      });
  }

  #calculateNumberOfCopies() {
    const childWidth = this.childElementWidth;
    const parentWidth = this.parentWidth;

    if (childWidth <= 0 || parentWidth <= 0) {
      return MarqueeComponent.#MIN_COPIES;
    }

    const baseCopies = Math.ceil(parentWidth / childWidth);

    if (this.parallax) {
      const parallaxValue = this.#parseParallaxValue();
      const parallaxTranslate = Math.abs((parallaxValue * 100) / (1 + parallaxValue));
      const parallaxMultiplier = 1.5;
      const extraCopies = Math.ceil(parallaxTranslate / 10) + 4;
      return Math.ceil(baseCopies * parallaxMultiplier) + extraCopies;
    }

    return baseCopies + 2;
  }

  #initParallax() {
    this.#createParallaxAnimation();
    this.#initParallaxPauseObserver();
  }

  #createParallaxAnimation() {
    const parallaxValue = this.#parseParallaxValue();
    let translate = this.#calculateParallaxTranslate(parallaxValue);

    this.#scrollStop = scroll(
      animate(this.refs.inner, { transform: [`translateX(${translate}%)`, `translateX(0)`] }, { easing: "linear" }),
      {
        target: this,
        offset: ["start end", "end start"],
      }
    );
  }

  #parseParallaxValue() {
    const parallaxAttr = this.getAttribute("data-parallax");
    if (!parallaxAttr || parallaxAttr === "false") return 0;
    if (parallaxAttr === "true") return MarqueeComponent.#DEFAULT_PARALLAX;
    return parseFloat(parallaxAttr);
  }

  #calculateParallaxTranslate(parallaxValue) {
    let translate = (parallaxValue * 100) / (1 + parallaxValue);
    const isReverse = this.direction === "reverse" || this.direction === "right";

    if (!isReverse) {
      translate *= -1;
    }

    if (this.isRTL) {
      translate *= -1;
    }

    return translate;
  }

  #initParallaxPauseObserver() {
    this.#intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            this.#pauseParallax();
          } else {
            this.#resumeParallax();
          }
        });
      },
      {
        rootMargin: MarqueeComponent.#PAUSE_OBSERVER_MARGIN,
      }
    );
    this.#intersectionObserver.observe(this);
  }

  #pauseParallax() {
    this.classList.add("paused");
    if (this.#scrollStop) {
      this.#scrollStop();
      this.#scrollStop = null;
    }
  }

  #resumeParallax() {
    this.classList.remove("paused");
    if (!this.#scrollStop) {
      this.#createParallaxAnimation();
    }
  }

  #initPauseObserver() {
    this.#intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove("paused");
          } else {
            this.classList.add("paused");
          }
        });
      },
      {
        rootMargin: MarqueeComponent.#PAUSE_OBSERVER_MARGIN,
      }
    );
    this.#intersectionObserver.observe(this);
  }

  #setupResizeObserver() {
    this.#resizeObserver = new ResizeObserver(() => this.#setHeight());
    this.#resizeObserver.observe(this);
    window.addEventListener("resize", this.#handleResize);
  }

  #debounce(fn, wait) {
  /** @type {number | undefined} */
  let timeout;

  /** @param {...any} args */
  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }

  // Add the .cancel method:
  debounced.cancel = () => {
    clearTimeout(timeout);
  };

  return /** @type {T & { cancel(): void }} */ (debounced);
}

  #handleResize = this.#debounce(() => {
    const currentWidth = this.parentWidth;
    if (currentWidth === this.#previousWidth) return;

    this.#previousWidth = currentWidth;

    const { inner } = this.refs;
    if (!inner) return;

    const allItemsElements = inner.querySelectorAll(".marquee__items");
    allItemsElements.forEach((el) => {
      el.classList.remove("animate");
      el.style.transform = "";
    });

    if (this.parallax && this.#scrollStop) {
      this.#scrollStop();
      this.#scrollStop = null;
      inner.style.transform = "";
    }

    this.#adjustItemCount(true);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const currentItemsElements = inner.querySelectorAll(".marquee__items");
        currentItemsElements.forEach((el) => {
          el.classList.add("animate");
          el.style.transform = "";
        });

        if (this.parallax) {
          this.#createParallaxAnimation();
        }
      });
    });
  }, MarqueeComponent.#RESIZE_DEBOUNCE);

  #setHeight() {
    // Called from ResizeObserver, batch reads and writes
    const height = this.offsetHeight;
    const isRotated = this.classList.contains("marquee--rotated");

    // Batch writes after all reads
    this.style.setProperty("--block-height", `${height}px`);

    if (isRotated) {
      this.#setRotateOffsetWithHeight(height);
    } else {
      this.style.setProperty("--offset", "0px");
    }
  }

  #setRotateOffsetWithHeight(blockHeight) {
    const angleDeg =
      parseFloat(this.style.getPropertyValue("--angle-raw")) || parseFloat(this.style.getPropertyValue("--angle")) || 0;

    if (angleDeg === 0) {
      this.style.setProperty("--offset", "0px");
      return;
    }

    const angleRad = (Math.abs(angleDeg) * Math.PI) / 180;
    const offset = blockHeight * Math.tan(angleRad);

    this.style.setProperty("--offset", `${offset}px`);
  }

  #setRotateOffset() {
    // Legacy method - kept for compatibility
    // Now handled inline in #setHeight() to avoid double rAF
    if (!this.classList.contains("marquee--rotated")) {
      this.style.setProperty("--offset", "0px");
      return;
    }

    const angleDeg =
      parseFloat(this.style.getPropertyValue("--angle-raw")) || parseFloat(this.style.getPropertyValue("--angle")) || 0;
    if (angleDeg === 0) {
      this.style.setProperty("--offset", "0px");
      return;
    }

    const angleRad = (Math.abs(angleDeg) * Math.PI) / 180;
    const blockHeight = this.offsetHeight || parseFloat(this.style.getPropertyValue("--block-height")) || 0;
    const offset = blockHeight * Math.tan(angleRad);

    this.style.setProperty("--offset", `${offset}px`);
  }

  onPause() {
    this.classList.add("paused");
    if (this.parallax && this.#scrollStop) {
      this.#scrollStop();
      this.#scrollStop = null;
    }
  }

  onPlay() {
    this.classList.remove("paused");
    if (this.parallax && !this.#scrollStop) {
      this.#createParallaxAnimation();
    }
  }

  get direction() {
    return this.getAttribute("data-direction") || "forward";
  }

  get duration() {
    if (!this.hasAttribute("data-duration")) return null;
    const value = parseFloat(this.getAttribute("data-duration"));
    return isNaN(value) ? null : value;
  }

  get parallax() {
	return false;
    // if (isTouch()) return false;
    return this.#parseParallaxValue();
  }

  get parentWidth() {
    const rect = this.getBoundingClientRect();
    return rect.right - rect.left;
  }

  get childElementWidth() {
    const { inner } = this.refs;
    const item = inner?.firstElementChild;
    if (!item) return 1;
    const rect = item.getBoundingClientRect();
    return rect.right - rect.left;
  }
}

if (!customElements.get("marquee-component")) {
  customElements.define("marquee-component", MarqueeComponent);
}

class FramerSectionSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var slider = this.querySelector('.framer-product-with-image-section-media-slider');
	var thumbs = this.querySelectorAll('.framer-product-with-image-section-media-slider-thumbs-item');
	var images = this.querySelectorAll('.framer-product-with-image-section-media-slider-item');
	if (slider) {
		const sliderFlkty = new Flickity(slider, {
			pageDots: true,
			prevNextButtons: true,
			wrapAround: false,
			watchCSS: true,
			cellAlign: 'left'
		});
	}

	if (thumbs.length && images.length) {
		thumbs.forEach(function (item) {
			item.addEventListener('click', function(e){
				images.forEach(function (el) {
					if (item.getAttribute('data-id') == el.getAttribute('data-id')) {
						el.classList.add('active');
					} else {
						el.classList.remove('active');
					}
				});
			});
		});
	}
  }
}

customElements.define("framer-section-slider", FramerSectionSlider);

document.addEventListener('DOMContentLoaded', () => {
	const productAboutSection = document.querySelector('.product-about-us-section-grid');
	if (productAboutSection != null) {
		const productAboutSectionSliderFlkty = new Flickity(productAboutSection, {
			pageDots: true,
			prevNextButtons: true,
			wrapAround: false,
			cellAlign: 'center',
			watchCSS: true
		});
	}
});













  